var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaticassetsPana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.27,444.1c12.8-8.94,15.7-25.54,15.2-40.46-.09-2.49.18-5.11-1-7.3s-4-3.68-6.18-2.63c-1.85.87-2.65,3-3.69,4.8a14.52,14.52,0,0,1-5.84,5.58c-1.58.82-3.55,1.33-5.11.46-2.15-1.18-2.4-4.15-2.39-6.63l.09-13.84a23.27,23.27,0,0,0-.75-7.36,7.67,7.67,0,0,0-4.83-5.19c-2.35-.66-5.27.69-5.76,3.12a22.55,22.55,0,0,0-.08,3.08,2.57,2.57,0,0,1-1.52,2.45c-1,.29-2-.41-2.72-1.13a32.73,32.73,0,0,1-5.91-8.93,45.8,45.8,0,0,0-5.52-9.21c-2.32-2.73-5.52-4.89-9.07-5.09s-7.33,2-8.22,5.47,1.13,7,3.35,9.86a55.17,55.17,0,0,0,11.51,11,4.64,4.64,0,0,1,1.93,2.07c.54,1.66-1,3.3-2.66,3.84-1.85.61-3.85.42-5.78.65s-4,1.08-4.75,2.9c-1,2.54,1.1,5.19,3.18,6.93a47.35,47.35,0,0,0,14,8.09,15.87,15.87,0,0,1,5.21,2.53c1.47,1.28,2.35,3.51,1.47,5.25s-3.17,2.3-5.08,1.95-3.62-1.39-5.43-2.08c-3.41-1.28-7.8-1.05-10,1.9a7.83,7.83,0,0,0-.84,6.93,18.22,18.22,0,0,0,3.76,6.12,47.63,47.63,0,0,0,20.33,14.29c7.9,2.74,15.21,3.48,23.06.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.47,455.16a108.69,108.69,0,0,0-4.05-20.41,223.16,223.16,0,0,0-8.81-23.9q-1.33-3.11-2.63-6.14c-.87-2-1.73-4-2.69-5.92a112.09,112.09,0,0,0-6.16-10.61c-2.12-3.28-4.26-6.32-6.27-9.14s-4-5.42-5.82-7.71a89.5,89.5,0,0,0-9.59-10.14c-1.23-1.1-2.2-1.93-2.87-2.48l-.77-.62-.27-.2a2.12,2.12,0,0,0,.24.24l.74.66c.65.57,1.61,1.41,2.81,2.54a92.41,92.41,0,0,1,9.46,10.21c1.84,2.29,3.76,4.89,5.76,7.72s4.12,5.87,6.23,9.15A110.66,110.66,0,0,1,328.89,399c.95,1.89,1.8,3.87,2.67,5.89s1.74,4.07,2.63,6.14A227.36,227.36,0,0,1,343,434.87a111.12,111.12,0,0,1,4.13,20.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,398.77a5.28,5.28,0,0,0,.24-1c.13-.69.28-1.68.46-2.92.35-2.46.72-5.88,1.11-9.66s.8-7.18,1.19-9.64c.19-1.22.35-2.22.47-2.9a4.94,4.94,0,0,0,.14-1.07,4.8,4.8,0,0,0-.31,1c-.17.68-.39,1.66-.62,2.89-.47,2.45-.94,5.86-1.33,9.64s-.71,7.1-1,9.67c-.13,1.17-.23,2.15-.32,2.93A4.21,4.21,0,0,0,329.16,398.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.31,392.82a6.9,6.9,0,0,0,1.27.16c.82.07,2,.17,3.46.34,2.92.31,6.93.89,11.33,1.72s8.35,1.76,11.19,2.51c1.42.37,2.56.7,3.35.92a7,7,0,0,0,1.25.3,7.8,7.8,0,0,0-1.19-.47c-.78-.28-1.91-.65-3.33-1.06-2.82-.84-6.77-1.82-11.19-2.66A111.93,111.93,0,0,0,302.07,393c-1.47-.13-2.66-.18-3.48-.19A6.71,6.71,0,0,0,297.31,392.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,434.16a1.81,1.81,0,0,0,.22-.39c.14-.31.32-.69.54-1.15.47-1,1.11-2.47,1.88-4.3,1.53-3.64,3.5-8.75,5.59-14.41s4-10.79,5.46-14.46c.71-1.79,1.3-3.26,1.74-4.35l.47-1.18a1.9,1.9,0,0,0,.13-.43,1.81,1.81,0,0,0-.22.39c-.15.31-.33.69-.54,1.15-.47,1-1.11,2.47-1.88,4.3-1.53,3.64-3.5,8.75-5.59,14.41s-4,10.79-5.46,14.46c-.72,1.79-1.3,3.26-1.74,4.35l-.47,1.18C343.06,434,343,434.15,343,434.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.71,420.52a1.48,1.48,0,0,0,.42.18l1.23.41,4.53,1.47c3.83,1.24,9.09,3,14.91,5s11.1,3.7,14.95,4.86c1.93.58,3.49,1,4.58,1.33l1.25.33a1.37,1.37,0,0,0,.45.08,1.72,1.72,0,0,0-.42-.17l-1.23-.41-4.53-1.47c-3.83-1.24-9.09-3-14.91-5s-11.1-3.69-14.95-4.86c-1.93-.58-3.49-1-4.58-1.32l-1.25-.33A2.32,2.32,0,0,0,300.71,420.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.72,
    y: 215.86,
    width: 84.44,
    height: 69.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.39,
    y: 262.66,
    width: 92.31,
    height: 22.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,268.83a1,1,0,1,1-1-1A1,1,0,0,1,478.62,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,268.83a1,1,0,1,1-1.05-1A1,1,0,0,1,483.23,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.83,268.83a1,1,0,1,1-1.05-1A1,1,0,0,1,487.83,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.43,268.83a1,1,0,1,1-1.05-1A1,1,0,0,1,492.43,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.08,268.83a1,1,0,1,1-1-1A1,1,0,0,1,528.08,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.77,268.83a1,1,0,1,1-1-1A1,1,0,0,1,532.77,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,268.83a1,1,0,1,1-1-1A1,1,0,0,1,497,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.62,268.83a1,1,0,1,1-1-1A1,1,0,0,1,519.62,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.63,268.83a1,1,0,1,1-1-1A1,1,0,0,1,501.63,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.23,268.83a1,1,0,1,1-1-1A1,1,0,0,1,506.23,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.57,268.83a1,1,0,1,1-1.05-1A1,1,0,0,1,515.57,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,268.83a1,1,0,1,1-1-1A1,1,0,0,1,536.59,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.83,268.83a1,1,0,1,1-1-1A1,1,0,0,1,510.83,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,268.83a1,1,0,1,1-1-1A1,1,0,0,1,524,268.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.51,273.86a1,1,0,1,1,1,1A1,1,0,0,1,534.51,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.91,273.86a1,1,0,1,1,1,1A1,1,0,0,1,529.91,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3,273.86a1,1,0,1,1,1.05,1A1,1,0,0,1,525.3,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.7,273.86a1,1,0,1,1,1,1A1,1,0,0,1,520.7,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.05,273.86a1,1,0,1,1,1,1A1,1,0,0,1,485.05,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.36,273.86a1,1,0,1,1,1,1A1,1,0,0,1,480.36,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.1,273.86a1,1,0,1,1,1,1A1,1,0,0,1,516.1,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.51,273.86a1,1,0,1,1,1,1A1,1,0,0,1,493.51,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.5,273.86a1,1,0,1,1,1,1A1,1,0,0,1,511.5,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.9,273.86a1,1,0,1,1,1,1A1,1,0,0,1,506.9,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.56,273.86a1,1,0,1,1,1.05,1A1,1,0,0,1,497.56,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.54,273.86a1,1,0,1,1,1,1A1,1,0,0,1,476.54,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3,273.86a1,1,0,1,1,1,1A1,1,0,0,1,502.3,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.12,273.86a1,1,0,1,1,1.05,1A1,1,0,0,1,489.12,273.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,278.33a1,1,0,1,1-1-1A1,1,0,0,1,478.62,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,278.33a1,1,0,1,1-1.05-1A1,1,0,0,1,483.23,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.83,278.33a1,1,0,1,1-1.05-1A1,1,0,0,1,487.83,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.43,278.33a1,1,0,1,1-1.05-1A1,1,0,0,1,492.43,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527.04,
    cy: 278.33,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.73,
    cy: 278.33,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,278.33a1,1,0,1,1-1-1A1,1,0,0,1,497,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518.58,
    cy: 278.33,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.63,278.33a1,1,0,1,1-1-1A1,1,0,0,1,501.63,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.23,278.33a1,1,0,1,1-1-1A1,1,0,0,1,506.23,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.52,
    cy: 278.33,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,278.33a1,1,0,1,1-1-1A1,1,0,0,1,536.59,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.83,278.33a1,1,0,1,1-1-1A1,1,0,0,1,510.83,278.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.96,
    cy: 278.33,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 267.37,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 272.18,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 277.16,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.58 285.34 541.7 285.38 541.7 262.69 555.58 262.66 555.58 285.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.39,
    y: 235.3,
    width: 92.31,
    height: 22.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,241.48a1,1,0,1,1-1-1A1,1,0,0,1,478.62,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,241.48a1,1,0,1,1-1.05-1A1,1,0,0,1,483.23,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.83,241.48a1,1,0,1,1-1.05-1A1,1,0,0,1,487.83,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.43,241.48a1,1,0,1,1-1.05-1A1,1,0,0,1,492.43,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.08,241.48a1,1,0,1,1-1-1A1,1,0,0,1,528.08,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.77,241.48a1,1,0,1,1-1-1A1,1,0,0,1,532.77,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,241.48a1,1,0,1,1-1-1A1,1,0,0,1,497,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.62,241.48a1,1,0,1,1-1-1A1,1,0,0,1,519.62,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.63,241.48a1,1,0,1,1-1-1A1,1,0,0,1,501.63,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.23,241.48a1,1,0,1,1-1-1A1,1,0,0,1,506.23,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.57,241.48a1,1,0,1,1-1.05-1A1,1,0,0,1,515.57,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,241.48a1,1,0,1,1-1-1A1,1,0,0,1,536.59,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.83,241.48a1,1,0,1,1-1-1A1,1,0,0,1,510.83,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,241.48a1,1,0,1,1-1-1A1,1,0,0,1,524,241.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.51,246.5a1,1,0,1,1,1,1A1,1,0,0,1,534.51,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.91,246.5a1,1,0,1,1,1,1A1,1,0,0,1,529.91,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3,246.5a1,1,0,1,1,1.05,1A1,1,0,0,1,525.3,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.7,246.5a1,1,0,1,1,1,1A1,1,0,0,1,520.7,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.05,246.5a1,1,0,0,1,2.08,0,1,1,0,0,1-2.08,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.36,246.5a1,1,0,1,1,1,1A1,1,0,0,1,480.36,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.1,246.5a1,1,0,1,1,1,1A1,1,0,0,1,516.1,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.51,246.5a1,1,0,1,1,1,1A1,1,0,0,1,493.51,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.5,246.5a1,1,0,1,1,1,1A1,1,0,0,1,511.5,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.9,246.5a1,1,0,0,1,2.08,0,1,1,0,0,1-2.08,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.56,246.5a1,1,0,1,1,1.05,1A1,1,0,0,1,497.56,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.54,246.5a1,1,0,0,1,2.08,0,1,1,0,0,1-2.08,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3,246.5a1,1,0,0,1,2.08,0,1,1,0,0,1-2.08,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.12,246.5a1,1,0,1,1,1.05,1A1,1,0,0,1,489.12,246.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,251a1,1,0,1,1-1-1A1,1,0,0,1,478.62,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,251a1,1,0,1,1-1.05-1A1,1,0,0,1,483.23,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.83,251a1,1,0,1,1-1.05-1A1,1,0,0,1,487.83,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.43,251a1,1,0,1,1-1.05-1A1,1,0,0,1,492.43,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.08,251a1,1,0,1,1-1-1A1,1,0,0,1,528.08,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.77,251a1,1,0,1,1-1-1A1,1,0,0,1,532.77,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,251a1,1,0,1,1-1-1A1,1,0,0,1,497,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.62,251a1,1,0,1,1-1-1A1,1,0,0,1,519.62,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.63,251a1,1,0,1,1-1-1A1,1,0,0,1,501.63,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.23,251a1,1,0,1,1-1-1A1,1,0,0,1,506.23,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.57,251a1,1,0,1,1-1.05-1A1,1,0,0,1,515.57,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,251a1,1,0,1,1-1-1A1,1,0,0,1,536.59,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.83,251a1,1,0,1,1-1-1A1,1,0,0,1,510.83,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,251a1,1,0,1,1-1-1A1,1,0,0,1,524,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 240.01,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 244.82,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 249.8,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.58 257.98 541.7 258.02 541.7 235.33 555.58 235.3 555.58 257.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.39,
    y: 208.83,
    width: 92.31,
    height: 22.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,215a1,1,0,1,1-1-1A1,1,0,0,1,478.62,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,215a1,1,0,1,1-1.05-1A1,1,0,0,1,483.23,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.83,215a1,1,0,1,1-1.05-1A1,1,0,0,1,487.83,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.43,215a1,1,0,1,1-1.05-1A1,1,0,0,1,492.43,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.08,215a1,1,0,1,1-1-1A1,1,0,0,1,528.08,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.77,215a1,1,0,1,1-1-1A1,1,0,0,1,532.77,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,215a1,1,0,1,1-1-1A1,1,0,0,1,497,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.62,215a1,1,0,1,1-1-1A1,1,0,0,1,519.62,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.63,215a1,1,0,1,1-1-1A1,1,0,0,1,501.63,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.23,215a1,1,0,1,1-1-1A1,1,0,0,1,506.23,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.57,215a1,1,0,1,1-1.05-1A1,1,0,0,1,515.57,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,215a1,1,0,1,1-1-1A1,1,0,0,1,536.59,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.83,215a1,1,0,1,1-1-1A1,1,0,0,1,510.83,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,215a1,1,0,1,1-1-1A1,1,0,0,1,524,215Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.51,220a1,1,0,1,1,1,1A1,1,0,0,1,534.51,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.91,220a1,1,0,1,1,1,1A1,1,0,0,1,529.91,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3,220a1,1,0,1,1,1.05,1A1,1,0,0,1,525.3,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.7,220a1,1,0,1,1,1,1A1,1,0,0,1,520.7,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.05,220a1,1,0,1,1,1,1A1,1,0,0,1,485.05,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.36,220a1,1,0,1,1,1,1A1,1,0,0,1,480.36,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.1,220a1,1,0,1,1,1,1A1,1,0,0,1,516.1,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.51,220a1,1,0,1,1,1,1A1,1,0,0,1,493.51,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.5,220a1,1,0,1,1,1,1A1,1,0,0,1,511.5,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.9,220a1,1,0,1,1,1,1A1,1,0,0,1,506.9,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.56,220a1,1,0,1,1,1.05,1A1,1,0,0,1,497.56,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.54,220a1,1,0,1,1,1,1A1,1,0,0,1,476.54,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.3,220a1,1,0,1,1,1,1A1,1,0,0,1,502.3,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.12,220a1,1,0,1,1,1.05,1A1,1,0,0,1,489.12,220Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,224.51a1,1,0,1,1-1-1A1,1,0,0,1,478.62,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,224.51a1,1,0,1,1-1.05-1A1,1,0,0,1,483.23,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.83,224.51a1,1,0,1,1-1.05-1A1,1,0,0,1,487.83,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.43,224.51a1,1,0,1,1-1.05-1A1,1,0,0,1,492.43,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527.04,
    cy: 224.51,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.73,
    cy: 224.51,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,224.51a1,1,0,1,1-1-1A1,1,0,0,1,497,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518.58,
    cy: 224.51,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.63,224.51a1,1,0,1,1-1-1A1,1,0,0,1,501.63,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.23,224.51a1,1,0,1,1-1-1A1,1,0,0,1,506.23,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.52,
    cy: 224.51,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,224.51a1,1,0,1,1-1-1A1,1,0,0,1,536.59,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.83,224.51a1,1,0,1,1-1-1A1,1,0,0,1,510.83,224.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.96,
    cy: 224.51,
    r: 1.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 213.55,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 218.36,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.49,
    y: 223.33,
    width: 18.18,
    height: 2.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.58 231.52 541.7 231.56 541.7 208.87 555.58 208.83 555.58 231.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.67,
    y: 214.88,
    width: 81.01,
    height: 66.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.84,
    y: 259.78,
    width: 88.56,
    height: 21.97,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88,265.7a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,265.7a1,1,0,1,1-1-1A1,1,0,0,1,230.3,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,265.7a1,1,0,1,1-1-1A1,1,0,0,1,234.71,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13,265.7a1,1,0,1,1-1-1A1,1,0,0,1,239.13,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,265.7a1,1,0,1,1-1-1A1,1,0,0,1,273.33,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,265.7a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,265.7a1,1,0,1,1-1-1A1,1,0,0,1,243.54,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,265.7a1,1,0,1,1-1-1A1,1,0,0,1,265.22,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,265.7a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,265.7a1,1,0,1,1-1-1A1,1,0,0,1,252.37,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,265.7a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,265.7a1,1,0,1,1-1-1A1,1,0,0,1,281.5,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,265.7a1,1,0,1,1-1-1A1,1,0,0,1,256.78,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,265.7a1,1,0,1,1-1-1A1,1,0,0,1,269.42,265.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.49,270.52a1,1,0,1,1,1,1A1,1,0,0,1,279.49,270.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,270.52a1,1,0,1,1,1,1A1,1,0,0,1,275.08,270.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.67,270.52a1,1,0,1,1,1,1A1,1,0,0,1,270.67,270.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25,270.52a1,1,0,0,1,2,0,1,1,0,0,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.05,
    cy: 270.52,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.55,270.52a1,1,0,1,1,1,1A1,1,0,0,1,227.55,270.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.84,270.52a1,1,0,1,1,1,1A1,1,0,0,1,261.84,270.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.16,
    cy: 270.52,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,270.52a1,1,0,0,1,2,0,1,1,0,0,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,270.52a1,1,0,1,1,1,1A1,1,0,0,1,253,270.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.05,
    cy: 270.52,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.88,
    cy: 270.52,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.6,
    cy: 270.52,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.96,
    cy: 270.52,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.88,
    cy: 274.81,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,274.81a1,1,0,1,1-1-1A1,1,0,0,1,230.3,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,274.81a1,1,0,1,1-1-1A1,1,0,0,1,234.71,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13,274.81a1,1,0,1,1-1-1A1,1,0,0,1,239.13,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,274.81a1,1,0,1,1-1-1A1,1,0,0,1,273.33,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,274.81a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,274.81a1,1,0,1,1-1-1A1,1,0,0,1,243.54,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,274.81a1,1,0,1,1-1-1A1,1,0,0,1,265.22,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,274.81a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,274.81a1,1,0,1,1-1-1A1,1,0,0,1,252.37,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,274.81a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,274.81a1,1,0,1,1-1-1A1,1,0,0,1,281.5,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,274.81a1,1,0,1,1-1-1A1,1,0,0,1,256.78,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,274.81a1,1,0,1,1-1-1A1,1,0,0,1,269.42,274.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 264.3,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 268.92,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 273.69,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.71 281.54 286.4 281.58 286.4 259.81 299.71 259.77 299.71 281.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.84,
    y: 233.53,
    width: 88.56,
    height: 21.97,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88,239.46a1,1,0,1,1-1-1A1,1,0,0,1,225.88,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,239.46a1,1,0,1,1-1-1A1,1,0,0,1,230.3,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,239.46a1,1,0,1,1-1-1A1,1,0,0,1,234.71,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13,239.46a1,1,0,1,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,239.46a1,1,0,1,1-1-1A1,1,0,0,1,273.33,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,239.46a1,1,0,1,1-1-1A1,1,0,0,1,277.83,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,239.46a1,1,0,1,1-1-1A1,1,0,0,1,243.54,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,239.46a1,1,0,1,1-1-1A1,1,0,0,1,265.22,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,239.46a1,1,0,1,1-1-1A1,1,0,0,1,248,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,239.46a1,1,0,1,1-1-1A1,1,0,0,1,252.37,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,239.46a1,1,0,1,1-1-1A1,1,0,0,1,261.32,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,239.46a1,1,0,1,1-1-1A1,1,0,0,1,281.5,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,239.46a1,1,0,1,1-1-1A1,1,0,0,1,256.78,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,239.46a1,1,0,1,1-1-1A1,1,0,0,1,269.42,239.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.49,244.28a1,1,0,1,1,1,1A1,1,0,0,1,279.49,244.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,244.28a1,1,0,1,1,1,1A1,1,0,0,1,275.08,244.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.67,244.28a1,1,0,0,1,2,0,1,1,0,1,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25,244.28a1,1,0,1,1,1,1A1,1,0,0,1,266.25,244.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.05,
    cy: 244.28,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.55,244.28a1,1,0,0,1,2,0,1,1,0,1,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.84,244.28a1,1,0,1,1,1,1A1,1,0,0,1,261.84,244.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.16,
    cy: 244.28,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,244.28a1,1,0,1,1,1,1A1,1,0,0,1,257.42,244.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,244.28a1,1,0,1,1,1,1A1,1,0,0,1,253,244.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.05,
    cy: 244.28,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.88,
    cy: 244.28,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.6,
    cy: 244.28,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.96,
    cy: 244.28,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88,248.57a1,1,0,1,1-1-1A1,1,0,0,1,225.88,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,248.57a1,1,0,1,1-1-1A1,1,0,0,1,230.3,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,248.57a1,1,0,1,1-1-1A1,1,0,0,1,234.71,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13,248.57a1,1,0,1,1-1-1A1,1,0,0,1,239.13,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,248.57a1,1,0,1,1-1-1A1,1,0,0,1,273.33,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,248.57a1,1,0,1,1-1-1A1,1,0,0,1,277.83,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,248.57a1,1,0,1,1-1-1A1,1,0,0,1,243.54,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,248.57a1,1,0,1,1-1-1A1,1,0,0,1,265.22,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,248.57a1,1,0,1,1-1-1A1,1,0,0,1,248,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,248.57a1,1,0,1,1-1-1A1,1,0,0,1,252.37,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,248.57a1,1,0,1,1-1-1A1,1,0,0,1,261.32,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,248.57a1,1,0,1,1-1-1A1,1,0,0,1,281.5,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,248.57a1,1,0,1,1-1-1A1,1,0,0,1,256.78,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,248.57a1,1,0,1,1-1-1A1,1,0,0,1,269.42,248.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 238.05,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 242.67,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 247.44,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.71 255.29 286.4 255.33 286.4 233.56 299.71 233.53 299.71 255.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.84,
    y: 208.14,
    width: 88.56,
    height: 21.97,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.88,
    cy: 214.07,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,214.07a1,1,0,1,1-1-1A1,1,0,0,1,230.3,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,214.07a1,1,0,1,1-1-1A1,1,0,0,1,234.71,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13,214.07a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,214.07a1,1,0,1,1-1-1A1,1,0,0,1,273.33,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,214.07a1,1,0,1,1-1-1A1,1,0,0,1,277.83,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,214.07a1,1,0,1,1-1-1A1,1,0,0,1,243.54,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,214.07a1,1,0,1,1-1-1A1,1,0,0,1,265.22,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,214.07a1,1,0,1,1-1-1A1,1,0,0,1,248,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,214.07a1,1,0,1,1-1-1A1,1,0,0,1,252.37,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,214.07a1,1,0,1,1-1-1A1,1,0,0,1,261.32,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,214.07a1,1,0,1,1-1-1A1,1,0,0,1,281.5,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,214.07a1,1,0,1,1-1-1A1,1,0,0,1,256.78,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,214.07a1,1,0,1,1-1-1A1,1,0,0,1,269.42,214.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.49,218.89a1,1,0,1,1,1,1A1,1,0,0,1,279.49,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,218.89a1,1,0,1,1,1,1A1,1,0,0,1,275.08,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.67,218.89a1,1,0,0,1,2,0,1,1,0,0,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25,218.89a1,1,0,1,1,1,1A1,1,0,0,1,266.25,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.05,218.89a1,1,0,0,1,2,0,1,1,0,0,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.55,218.89a1,1,0,0,1,2,0,1,1,0,0,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.84,218.89a1,1,0,1,1,1,1A1,1,0,0,1,261.84,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.16,218.89a1,1,0,1,1,1,1A1,1,0,0,1,240.16,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,218.89a1,1,0,1,1,1,1A1,1,0,0,1,257.42,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,218.89a1,1,0,1,1,1,1A1,1,0,0,1,253,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.05,218.89a1,1,0,1,1,1,1A1,1,0,0,1,244.05,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,218.89a1,1,0,1,1,1,1A1,1,0,0,1,223.88,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.6,218.89a1,1,0,0,1,2,0,1,1,0,0,1-2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,218.89a1,1,0,1,1,1,1A1,1,0,0,1,236,218.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88,223.18a1,1,0,1,1-1-1A1,1,0,0,1,225.88,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,223.18a1,1,0,1,1-1-1A1,1,0,0,1,230.3,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,223.18a1,1,0,1,1-1-1A1,1,0,0,1,234.71,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13,223.18a1,1,0,0,1-2,0,1,1,0,0,1,2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,223.18a1,1,0,1,1-1-1A1,1,0,0,1,273.33,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,223.18a1,1,0,1,1-1-1A1,1,0,0,1,277.83,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,223.18a1,1,0,1,1-1-1A1,1,0,0,1,243.54,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,223.18a1,1,0,1,1-1-1A1,1,0,0,1,265.22,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,223.18a1,1,0,1,1-1-1A1,1,0,0,1,248,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,223.18a1,1,0,1,1-1-1A1,1,0,0,1,252.37,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,223.18a1,1,0,1,1-1-1A1,1,0,0,1,261.32,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,223.18a1,1,0,1,1-1-1A1,1,0,0,1,281.5,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,223.18a1,1,0,1,1-1-1A1,1,0,0,1,256.78,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,223.18a1,1,0,1,1-1-1A1,1,0,0,1,269.42,223.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 212.66,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 217.28,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 222.05,
    width: 17.44,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.71 229.9 286.4 229.94 286.4 208.17 299.71 208.14 299.71 229.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.42,
    y: 219.1,
    width: 70.31,
    height: 101.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.9,
    y: 219.1,
    width: 70.31,
    height: 101.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.64,
    y: 230.13,
    width: 52.84,
    height: 79.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.48,310s0-.13,0-.39,0-.64,0-1.13c0-1,0-2.47,0-4.38,0-3.83,0-9.4-.05-16.45,0-14.07,0-34-.09-57.49l.18.18-52.84,0h0l.19-.2c0,30.12,0,57.89,0,79.84l-.15-.15,38.46.08,10.62,0,2.79,0h1l-.93,0-2.77,0-10.59,0-38.55.08h-.15V310c0-22,0-49.72,0-79.84v-.19h.19l52.84,0h.17v.17c0,23.53-.06,43.5-.08,57.61,0,7,0,12.59-.05,16.41,0,1.89,0,3.34,0,4.34,0,.48,0,.85,0,1.11S661.48,310,661.48,310Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.41,219.1a12.77,12.77,0,0,1-1.25,1.82c-.82,1.09-2,2.58-3.3,4.18s-2.56,3-3.48,4a11.65,11.65,0,0,1-1.54,1.58,13.52,13.52,0,0,1,1.34-1.75l3.38-4.11c1.28-1.56,2.44-3,3.39-4.11A12.62,12.62,0,0,1,670.41,219.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.75,309.72A65.51,65.51,0,0,0,671,321.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671,321.24a10.44,10.44,0,0,1-1.6-1.46,50.88,50.88,0,0,1-6.54-8.18,11,11,0,0,1-1.07-1.88,14.48,14.48,0,0,1,1.29,1.73c.78,1.09,1.87,2.58,3.14,4.17s2.48,3,3.37,4A14.86,14.86,0,0,1,671,321.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.89,320.93l9.21-11.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.1,309.57a72.45,72.45,0,0,1-4.45,5.8,70.06,70.06,0,0,1-4.76,5.56,142.14,142.14,0,0,1,9.21-11.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.9,219.1a61,61,0,0,1,4.47,5.34,62.43,62.43,0,0,1,4.17,5.58,63.16,63.16,0,0,1-4.47-5.34A67.54,67.54,0,0,1,599.9,219.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.32,
    y: 246.34,
    width: 17.69,
    height: 50.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "704.8 106.13 704.8 164.95 620.32 164.95 617.27 106.54 704.8 106.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.37,
    y: 93.45,
    width: 58.28,
    height: 84.48,
    transform: "translate(523.83 795.2) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.15,165.23H616.87V106.14h85.28Zm-84.48-.8h83.68V106.94H617.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.42,
    y: 113.78,
    width: 66.18,
    height: 43.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.6,113.78l-.32,0h-.94l-3.64,0-13.64,0-47.64.1.19-.2c0,13.39,0,28.21,0,43.8h0l-.21-.2,66.18,0-.16.16c0-13.32.06-24.25.08-31.86l.05-8.82c0-1,0-1.78,0-2.31s0-.81,0-.81,0,.26,0,.77,0,1.29,0,2.29c0,2,0,5,0,8.77,0,7.64.05,18.6.09,32v.17h-.17l-66.18,0h-.21v-.21h0c0-15.59,0-30.41,0-43.8v-.19h.19l47.77.1,13.59,0,3.6,0h1.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.27,106.38a7,7,0,0,1,1.46.94c.86.62,2,1.51,3.31,2.53s2.39,2,3.17,2.7a6.82,6.82,0,0,1,1.21,1.23,56.67,56.67,0,0,1-4.64-3.61A47.67,47.67,0,0,1,617.27,106.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.75,106.54a41.26,41.26,0,0,1-4.44,3.79,40.59,40.59,0,0,1-4.71,3.45,41.47,41.47,0,0,1,4.45-3.78A40.9,40.9,0,0,1,701.75,106.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.69,164.83l-9.42-7.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.27,157.2a87.56,87.56,0,0,1,9.42,7.63,43.13,43.13,0,0,1-4.85-3.65A42.89,42.89,0,0,1,692.27,157.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.27,164.83a40.49,40.49,0,0,1,4.4-3.75,40,40,0,0,1,4.66-3.42,40.49,40.49,0,0,1-4.4,3.75A39.08,39.08,0,0,1,617.27,164.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.35,
    y: 113.94,
    width: 14.67,
    height: 41.64,
    transform: "translate(525.92 795.44) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.24,
    y: 163.55,
    width: 76.07,
    height: 125.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.71,
    y: 163.55,
    width: 76.07,
    height: 125.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.95,
    y: 166.1,
    width: 69.59,
    height: 120.81,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.19,
    y: 181.8,
    width: 42.79,
    height: 89.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.19,239.57c-.1-8.35,7.41-16.51,15.69-17.67,3.94-.56,8.13.22,11.81-1.29,6.58-2.69,8.67-11.43,15.29-14l.31,64.63H79.19Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.71,456c0,.15-148.52.26-331.69.26S43.29,456.1,43.29,456s148.49-.26,331.73-.26S706.71,455.81,706.71,456Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.83,401.77l3.82,12a13.81,13.81,0,0,0,10.73,9.61l25.55,4.8,7-.22-7-8.61-19.2-6.54a5.17,5.17,0,0,1-3.88-3.68l-7.64-16.64-9.69,5.94Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.06,322.48c3.41-2.34,9.55-1.89,13.11.2s5.39,4.88,6.08,9.75a29.32,29.32,0,0,1,.57,5.17,5.16,5.16,0,0,0,1.26,4.11c1,1,2.65,1.33,3.35,2.56a2.33,2.33,0,0,1-2.74,3.37,2.26,2.26,0,0,1-1,2.77,4.23,4.23,0,0,1-3.15.27,8,8,0,0,1-5.87-7.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.8,455.91c-17.55-5.81-5.51-29-5.51-29L618,434.11a11.09,11.09,0,0,1,11.17,11.09h0a11.1,11.1,0,0,1-11.09,11.1l-71.25-.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.85,455.89c-17.1-5.77-5.32-29-5.32-29l74.76,7.05c7.3.09,10.87,3.62,10.87,11.07h0c0,6.12-2.28,11.29-10.84,11.11l-69.47-.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.2,430.81h.21l.63,0,2.39.1,8.8.43,29,1.59c1.41.07,2.81.19,4.19.21s2.75.08,4.09.16,2.65.18,3.93.32a14.22,14.22,0,0,1,3.74.77,9.21,9.21,0,0,1,3.11,2,8.19,8.19,0,0,1,1.88,3,14.61,14.61,0,0,1,.77,3.27,23.83,23.83,0,0,1,.21,3.09,13.26,13.26,0,0,1-1,5.21,8.62,8.62,0,0,1-2.32,3.16,6.3,6.3,0,0,1-2.12,1.2c-.53.17-.54.11,0-.08a6.35,6.35,0,0,0,2-1.24,8.68,8.68,0,0,0,2.23-3.14,13,13,0,0,0,.91-5.11,23.49,23.49,0,0,0-.23-3,15,15,0,0,0-.77-3.19,8,8,0,0,0-1.82-2.89,8.82,8.82,0,0,0-3-1.9,13.59,13.59,0,0,0-3.66-.73c-1.27-.14-2.58-.23-3.92-.31s-2.69-.13-4.06-.15-2.79-.14-4.2-.21l-29-1.71-8.79-.57L547,430.9l-.62,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.32,438.13a1.75,1.75,0,0,0,.61.3,6.1,6.1,0,0,0,1.81.37,7.08,7.08,0,0,0,7.6-7.79,6.5,6.5,0,0,0-.41-1.8,1.82,1.82,0,0,0-.32-.6,12.25,12.25,0,0,1,.44,2.42,7,7,0,0,1-7.3,7.48A12,12,0,0,1,529.32,438.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.83,363.91c9.52,1.07,11.06,7.53,15.5,13.89l6.41,11.84L562,396.87l.4,18.17,4.83,16.08-44.43-2.51,5.48-19L521.78,390a36.2,36.2,0,0,1,.76-12c3.27-11.58,11.15-12.89,18.14-14.71a46.14,46.14,0,0,1,9.61-.05",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528,403.76a91,91,0,0,0,3.27,11.39,24.87,24.87,0,0,0,3.59,6.58,16.66,16.66,0,0,0,8.6,5.24,27,27,0,0,0,10.17.5l-16.9-9.54-4.49-15.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M562.34,414.54a7.41,7.41,0,0,1-.12-1.29c0-.9-.1-2.09-.17-3.52-.12-3-.27-7.08-.41-11.62s-.24-8.65-.29-11.63c0-1.43,0-2.62,0-3.52a7.76,7.76,0,0,1,0-1.3,7.58,7.58,0,0,1,.12,1.29c0,.9.1,2.09.17,3.52.13,3,.27,7.09.41,11.63s.24,8.65.29,11.62c0,1.44,0,2.63,0,3.53A7.67,7.67,0,0,1,562.34,414.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.54,389.86a1.68,1.68,0,0,1,.09.25l.25.75c.22.67.52,1.64.91,2.86L527,404.09l-.15-.07,19.75-7.29.5-.2-.09.16a87.42,87.42,0,0,0-4.62-13,36.72,36.72,0,0,0-5.87-9.52,13,13,0,0,0-3.32-2.68,6.71,6.71,0,0,0-3.07-.91,3.37,3.37,0,0,0-.63,0l-.55.06c-.17,0-.33,0-.47.05l-.38.11-.51.13-.18,0,.17-.07.51-.16.38-.11a3.11,3.11,0,0,1,.47-.07l.56-.08a4.46,4.46,0,0,1,.63,0,6.89,6.89,0,0,1,3.14.88,12.87,12.87,0,0,1,3.39,2.69,36.23,36.23,0,0,1,6,9.55,85.19,85.19,0,0,1,4.67,13l0,.12-.12,0-.49.21c-7.4,2.77-14.26,5.23-19.78,7.24l-.11,0,0-.11c-1.3-4.33-2.38-7.9-3.13-10.4-.37-1.23-.65-2.2-.85-2.88-.09-.32-.17-.57-.22-.76A.88.88,0,0,1,522.54,389.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.82,403.19l4.27,13.33a13.88,13.88,0,0,0,10.74,9.74l25.55,4.86,7-.23L575,425l-23.79-9.41a5.16,5.16,0,0,1-3.87-3.73l-3.56-13.72Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.56 431.3 552.78 429.64 572.41 428.87 582.04 404.58 618.73 407.07 606.35 434.03 552.56 431.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.48,420.34a1.92,1.92,0,1,1-.6-2.66A1.92,1.92,0,0,1,596.48,420.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.38,323.62c-12.12-5.83-18.23,2.4-20.11,7.83-.35,1-.59,2.07-1,3.05a4.56,4.56,0,0,1-2.12,2.35c-.72.32-1.54.36-2.28.63a4.15,4.15,0,0,0-2.52,2.92,5.05,5.05,0,0,0,.68,3.84,4,4,0,0,1,.86,1.79,4.71,4.71,0,0,1-.28,1.33,3.64,3.64,0,0,0,6,3.55,5.11,5.11,0,0,0,2.21,2.77c1.09.52,2.69.05,2.92-1.13a2.87,2.87,0,0,0,5.46-1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.09,329.49a2.58,2.58,0,0,0-2.3,2.61h0l1.46,34.69c.06,4.1,6,6.41,10.42,6.32h0c4.43-.09,4.58-2.27,4.65-6.16.1-6.52.1-9,.1-8.92s5.6-.93,6.76-8.23c.58-3.64.39-9.59.09-14.46-.28-4.38-3.18-9.75-7.55-9.29Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.37,340.07a.93.93,0,0,1-.9.94.9.9,0,0,1-1-.84.94.94,0,0,1,.9-.95A.9.9,0,0,1,557.37,340.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558,338.44c-.12.12-.83-.4-1.84-.4s-1.74.51-1.85.38.06-.27.38-.51a2.63,2.63,0,0,1,1.49-.46,2.5,2.5,0,0,1,1.46.48C557.93,338.16,558,338.38,558,338.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.52,340.07a.93.93,0,0,1-.91.94.89.89,0,0,1-1-.84.94.94,0,0,1,.9-.95A.9.9,0,0,1,547.52,340.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.07,338.63c-.12.12-.83-.41-1.83-.4s-1.75.5-1.86.38.06-.27.39-.51a2.56,2.56,0,0,1,2.94,0C548,338.35,548.13,338.57,548.07,338.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.73,346.1a6.59,6.59,0,0,1,1.63-.29c.26,0,.5-.08.55-.26a1.35,1.35,0,0,0-.17-.76c-.25-.62-.5-1.28-.76-2a32,32,0,0,1-1.71-5.13,34,34,0,0,1,2.11,5c.26.69.5,1.34.73,2a1.49,1.49,0,0,1,.14,1,.67.67,0,0,1-.43.38,1.84,1.84,0,0,1-.43.06A6.57,6.57,0,0,1,551.73,346.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.42,358a18.65,18.65,0,0,1-9.78-2.61s2.38,5,9.68,4.33Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.3,348.53a1.81,1.81,0,0,0-1.63-.67,1.61,1.61,0,0,0-1.14.61,1,1,0,0,0-.08,1.2,1.23,1.23,0,0,0,1.32.34,4.06,4.06,0,0,0,1.29-.77,1.18,1.18,0,0,0,.29-.3.35.35,0,0,0,0-.38",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.76,346.8c.16,0,.17,1.08,1.1,1.86s2.1.66,2.11.81-.26.21-.75.22a2.67,2.67,0,0,1-1.76-.61,2.34,2.34,0,0,1-.85-1.56C548.56,347.06,548.69,346.79,548.76,346.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.52,336.86c-.1.28-1.1.15-2.29.29s-2.13.46-2.29.22.1-.38.48-.64a3.76,3.76,0,0,1,1.7-.6,3.87,3.87,0,0,1,1.79.21C548.35,336.52,548.57,336.73,548.52,336.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.61,335.52c-.18.23-.88,0-1.71,0s-1.54.16-1.71-.08,0-.35.35-.56a2.34,2.34,0,0,1,1.39-.38,2.41,2.41,0,0,1,1.36.46C557.59,335.18,557.68,335.41,557.61,335.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.6,341.17a1.83,1.83,0,0,0-1.91.1,3.39,3.39,0,0,0,2.14,6.29",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.08,323.61a14.82,14.82,0,0,1,7,2.18,10.16,10.16,0,0,1,5,5.95,2.09,2.09,0,0,1-.06,1.65,1.61,1.61,0,0,1-2,.43,4.77,4.77,0,0,1-1.63-1.5,3.12,3.12,0,0,1-6.06-.07,2.75,2.75,0,0,1-2.82,2.51,3.62,3.62,0,0,1-3.11-2.45,9.22,9.22,0,0,1-1.28,3.56,3.14,3.14,0,0,1-3.31,1.35,6.42,6.42,0,0,1-.05,3.26,2.21,2.21,0,0,1-2.57,1.51c-1-.34-1.41-1.54-1.64-2.58a24.49,24.49,0,0,1-.79-6.13,9.91,9.91,0,0,1,1.89-5.78,9.78,9.78,0,0,1,5.35-3.3,23.32,23.32,0,0,1,6.35-.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.09,345.38c0-.05-.28.06-.63-.1a1.26,1.26,0,0,1-.63-1.25,1.29,1.29,0,0,1,.78-1.17c.36-.15.63-.08.65-.13s-.25-.23-.73-.13a1.47,1.47,0,0,0-.72.45,1.7,1.7,0,0,0-.36,1,1.45,1.45,0,0,0,.92,1.52C535.86,345.66,536.13,345.41,536.09,345.38Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.87,324.47a18.84,18.84,0,0,0-4.46-1.61,14.29,14.29,0,0,0-5.1-.1,13.09,13.09,0,0,0-9.79,7,14.57,14.57,0,0,0-1.54,4.87,19.7,19.7,0,0,0,.1,4.74,5,5,0,0,1-.34-1.25,12.63,12.63,0,0,1-.13-3.53,14.24,14.24,0,0,1,1.48-5.05,13.23,13.23,0,0,1,10.14-7.29,14.5,14.5,0,0,1,5.26.2,13.09,13.09,0,0,1,3.31,1.25A4.28,4.28,0,0,1,556.87,324.47Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.63,392a18.9,18.9,0,0,1-3,1c-1.86.54-4.43,1.29-7.24,2.2s-5.34,1.8-7.17,2.45a20.6,20.6,0,0,1-3,1,18,18,0,0,1,2.86-1.32c1.8-.74,4.31-1.69,7.14-2.6s5.42-1.61,7.31-2.07A18.28,18.28,0,0,1,545.63,392Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.75,387.11c0,.14-4.38,1.93-9.89,4s-10,3.66-10.08,3.52,4.38-1.93,9.9-4S543.7,387,543.75,387.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.43,379c0,.14-5.14,2-11.58,4.24s-11.7,3.89-11.75,3.75,5.14-2,11.58-4.24S567.38,378.89,567.43,379Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,386.93a60.13,60.13,0,0,1-7.29,2.72,56.68,56.68,0,0,1-7.45,2.24,56.7,56.7,0,0,1,7.28-2.73A57.34,57.34,0,0,1,561,386.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.55,383.17a17.14,17.14,0,0,1-3.68,1.94,16.64,16.64,0,0,1-3.9,1.46,32.81,32.81,0,0,1,7.58-3.4Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.22,432,385,429c-.31-.71-.53-1.13-.53-1.13l-13.59.31-4.43-.26s-.07.13-.17.36l-45.64,1c-9.1,0-18.66,5.6-18.64,12.7-.09,6.75,3.2,14.07,11.35,13.88l62.19-.37,62.19,0c8.15.14,10.29-4.78,10.29-10.61C449,434.12,442.17,432.05,435.22,432Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.1,455.92l.3,0,.88,0,3.38,0,12.52-.08,41.75-.17-.17.19c-.09-1.37-.19-2.83-.28-4.3-.2-3-.39-6-.57-8.78l.15.16-38.47-4.17-11.41-1.28-3.07-.36-.79-.1-.27,0a1.37,1.37,0,0,1,.27,0l.8.07,3.08.3,11.41,1.17,38.49,4.06h.15v.15c.18,2.81.37,5.77.57,8.78.09,1.47.19,2.93.28,4.29v.19h-.19l-41.75.06-12.52,0-3.38,0h-.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.87,438.05s-.66-.46-1.76-1.12a18.92,18.92,0,0,0-4.57-2,19.22,19.22,0,0,0-4.94-.71c-1.28,0-2.08.08-2.09,0a2.62,2.62,0,0,1,.55-.13,13.94,13.94,0,0,1,1.54-.14,16.45,16.45,0,0,1,5,.63,16.19,16.19,0,0,1,4.61,2.12,10.37,10.37,0,0,1,1.23.93C331.74,437.89,331.89,438,331.87,438.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.33,435.11c0,.1-9.86,2.51-22.08,5.4s-22.14,5.16-22.17,5.07,9.87-2.52,22.09-5.41S431.31,435,431.33,435.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,434.17a19.36,19.36,0,0,0-3.88,1.86A19.64,19.64,0,0,0,416,439a3.47,3.47,0,0,1,.67-1.1,10.79,10.79,0,0,1,2.27-2.13,10.45,10.45,0,0,1,2.81-1.34A3.37,3.37,0,0,1,423,434.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.33 444.1 386.7 445.38 386.72 455.56 378.11 455.37 377.33 444.1",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7,445.38h4.21a4.64,4.64,0,0,1,2.33.62l2.23,1.28a35.24,35.24,0,0,0,3.88,1.84c2.57.81,6.88,1.91,7.79,2.61,2.59,2,1.81,4.35.39,4.6-1.25.22-20.81-.76-20.81-.76Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.64,454.7a6.46,6.46,0,0,1-.46-2.64,6.71,6.71,0,0,1,.29-2.67,23.8,23.8,0,0,1,.06,2.66A24.45,24.45,0,0,1,393.64,454.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.64,454.64a8.37,8.37,0,0,1-.16-2.43,8.78,8.78,0,0,1,.18-2.43,8.57,8.57,0,0,1,.17,2.43A8.93,8.93,0,0,1,395.64,454.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,455a17.57,17.57,0,0,1-.4-5,9.57,9.57,0,0,1,.37,2.49A9.16,9.16,0,0,1,398,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.81,452a3,3,0,0,1-.86-.27,7.83,7.83,0,0,1-2.11-1.29c-.2-.18-.4-.36-.61-.57a2.29,2.29,0,0,1-.53-.76,1,1,0,0,1,.11-1,.76.76,0,0,1,.52-.29,1.36,1.36,0,0,1,.57.06,4.2,4.2,0,0,1,.9,7.46,2.71,2.71,0,0,1-1,.44,1.14,1.14,0,0,1-.55,0,.75.75,0,0,1-.43-.37,1.07,1.07,0,0,1,.12-1,3.29,3.29,0,0,1,.54-.66,6.62,6.62,0,0,1,2.07-1.36,3.39,3.39,0,0,1,.87-.25s-.3.13-.81.38a6.88,6.88,0,0,0-1.95,1.41,2.81,2.81,0,0,0-.48.61.84.84,0,0,0-.1.71.58.58,0,0,0,.66.22,2.16,2.16,0,0,0,.84-.4,3.89,3.89,0,0,0-.82-6.88.66.66,0,0,0-.75.11.77.77,0,0,0-.08.75,4.14,4.14,0,0,0,1,1.24A11.39,11.39,0,0,0,391.81,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.53,456.32a2.28,2.28,0,0,0,.51-.64,2.39,2.39,0,0,0-.28-2.12,4.75,4.75,0,0,0-2.61-2c-1.19-.42-2.61-.62-4-1.07a28.15,28.15,0,0,1-7-3.15,21.48,21.48,0,0,1-1.9-1.33,3.82,3.82,0,0,1-.64-.56,4,4,0,0,1,.72.45c.45.3,1.11.74,1.95,1.23a31.15,31.15,0,0,0,6.94,3c1.41.43,2.81.64,4.05,1.1a4.9,4.9,0,0,1,2.72,2.14,2.5,2.5,0,0,1,.18,2.3,1.39,1.39,0,0,1-.43.48C407.61,456.3,407.54,456.33,407.53,456.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.82,321.8c-2.9,1.13-6.2,5.55-6.78,8.61-.52,2.69.18,5.45.54,8.18s.28,5.76-1.48,7.87c-1.1,1.31-2.7,2.07-4,3.19a9.38,9.38,0,0,0-.9,13.27,4.92,4.92,0,0,0-3.58,4.94,7.38,7.38,0,0,0,3.21,5.52,15.18,15.18,0,0,0,6.13,2.35,13.12,13.12,0,0,0,6.9-.19c2.57-.94,4.47-3.07,6.53-4.87,2.51-2.21,5.44-4.07,7.24-6.88,2.1-3.28,2.38-7.38,2.36-11.28a97.79,97.79,0,0,0-3-23.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.13,376.8l16,27.62a11.76,11.76,0,0,1,.35,11.11h0a11.74,11.74,0,0,1-10.83,6.52l-24.4-.62-.67-8.87L406,408.38l-14.55-25Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,424.3l22.45,5.88.47-6.73L347.25,411.5l15-28.08L349.58,377l-15.81,27.7h0a13,13,0,0,0,7.53,18.47Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,394.58l15.32-8.12a78.37,78.37,0,0,0-6.6-10.94,33.66,33.66,0,0,0-20.52-12.85h0l-17.64.25a23.42,23.42,0,0,0-6.28,1.47v-.07c-9.57,2.14-20.14,23.05-20.14,23.05l14,7.31.31,2.19a15,15,0,0,0,3.66,7.81l-4,26.74,45.29.82L395,413.11Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.94,404.83a4.14,4.14,0,0,1-.67-.51,9.61,9.61,0,0,1-1.55-1.72,11.25,11.25,0,0,1-1.91-7.28,23.47,23.47,0,0,1,1-4.07c.4-1.22.81-2.3,1.17-3.2s.66-1.62.88-2.12a4.15,4.15,0,0,1,.39-.75,5.11,5.11,0,0,1-.26.8l-.78,2.16c-.33.91-.71,2-1.1,3.21a26.15,26.15,0,0,0-1,4,11.57,11.57,0,0,0,.39,4.05,10.68,10.68,0,0,0,1.38,3A19.94,19.94,0,0,0,359.94,404.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,381.52a13,13,0,0,1-2.38-2.79,12.87,12.87,0,0,1-2-3.09,25.42,25.42,0,0,1,4.34,5.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.62,369.15a10.21,10.21,0,0,1-2.66,1.78,9.7,9.7,0,0,1-2.91,1.32,10.21,10.21,0,0,1,2.66-1.78A10,10,0,0,1,368.62,369.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.93,386.77a8.82,8.82,0,0,1,0-3,8.17,8.17,0,0,1,.49-2.92,8.72,8.72,0,0,1,0,3A8.26,8.26,0,0,1,350.93,386.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.23,392.55a9.39,9.39,0,0,1-2.54,1.71,9.25,9.25,0,0,1-2.79,1.27,8.86,8.86,0,0,1,2.54-1.72A9.06,9.06,0,0,1,367.23,392.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.56,380.35a9.18,9.18,0,0,1-1.77,2.39c-1.08,1.22-2.05,2.14-2.16,2a9.18,9.18,0,0,1,1.77-2.39C371.48,381.17,372.45,380.25,372.56,380.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.15,384a8,8,0,0,1-1.86-2.17,7.86,7.86,0,0,1-1.42-2.46,8.17,8.17,0,0,1,1.85,2.16A8.38,8.38,0,0,1,383.15,384Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.59,395.44a23.6,23.6,0,0,1-.68-7,12.29,12.29,0,0,1,.6,3.46A12,12,0,0,1,377.59,395.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.28,405.34a9.46,9.46,0,0,1-1.78-2.58,9.91,9.91,0,0,1-1.32-2.84A9.31,9.31,0,0,1,372,402.5,9.79,9.79,0,0,1,373.28,405.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.36,399.63a20,20,0,0,1-3.93,5.08,20,20,0,0,1,3.93-5.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.39,393.89a8.39,8.39,0,0,1-3.23-1.79,8.24,8.24,0,0,1-2.51-2.7,33.44,33.44,0,0,1,2.84,2.29A34,34,0,0,1,393.39,393.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15,385.72a11.67,11.67,0,0,1-3.48.35,11.43,11.43,0,0,1-3.49-.18,12.3,12.3,0,0,1,3.48-.34A12,12,0,0,1,403.15,385.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.6,373.17a9,9,0,0,1-13.88,11.25,6.5,6.5,0,0,0-1.58-1.34,6.84,6.84,0,0,0-1.92-.4,6.95,6.95,0,0,1-4.57-10.88Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "353.24 437.88 350.61 408.08 405.78 407.93 402.2 438.12 353.24 437.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.75,423.89a3.52,3.52,0,1,1-3.53-3.5A3.52,3.52,0,0,1,381.75,423.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.12,373.25a8.62,8.62,0,0,0,8.43-8.51l.4-34.26h0a2.74,2.74,0,0,0-2.44-2.77L371,324.05c-4.63-.49-7.71,5.22-8,9.87-.33,5.17-.52,11.49.09,15.34,1.23,7.76,7.17,8.74,7.17,8.74s0,3,0,6.68a8.62,8.62,0,0,0,8.81,8.57Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,338.94a1,1,0,0,0,1,1,1,1,0,0,0,1-.89,1,1,0,0,0-1-1A1,1,0,0,0,366,338.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.4,337.21c.12.13.87-.43,1.94-.43s1.86.54,2,.41-.07-.29-.41-.54a2.71,2.71,0,0,0-1.57-.49,2.66,2.66,0,0,0-1.55.5C364.45,336.92,364.34,337.15,364.4,337.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.21,338.94a1,1,0,0,0,1,1,.94.94,0,0,0,1-.89,1,1,0,0,0-.95-1A1,1,0,0,0,376.21,338.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.91,337.41c.13.13.88-.43,1.95-.43s1.85.54,2,.41-.07-.29-.41-.54a2.74,2.74,0,0,0-1.58-.49,2.71,2.71,0,0,0-1.55.5C375,337.12,374.85,337.35,374.91,337.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,345.34a7.32,7.32,0,0,0-1.74-.31c-.27,0-.53-.08-.57-.27a1.36,1.36,0,0,1,.18-.81c.25-.66.52-1.35.81-2.08a35.72,35.72,0,0,0,1.81-5.44,35.09,35.09,0,0,0-2.25,5.28l-.77,2.09a1.56,1.56,0,0,0-.14,1.08.69.69,0,0,0,.45.4,2,2,0,0,0,.46.06A6.82,6.82,0,0,0,371,345.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.29,358a19.66,19.66,0,0,0,10.38-2.77s-2.51,5.33-10.27,4.6Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.48,347.92a1.91,1.91,0,0,1,1.73-.71,1.77,1.77,0,0,1,1.22.65,1.1,1.1,0,0,1,.08,1.27,1.29,1.29,0,0,1-1.4.36,4.1,4.1,0,0,1-1.37-.82,1.14,1.14,0,0,1-.3-.32.33.33,0,0,1,0-.39",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,346.08c-.17,0-.18,1.15-1.17,2s-2.23.7-2.24.86.28.22.8.24a2.91,2.91,0,0,0,1.87-.65,2.54,2.54,0,0,0,.9-1.66C374.39,346.36,374.26,346.08,374.18,346.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.43,335.53c.11.3,1.18.16,2.43.31s2.27.49,2.44.23-.1-.4-.51-.68a4.09,4.09,0,0,0-1.81-.63,4.19,4.19,0,0,0-1.9.22C374.62,335.17,374.39,335.4,374.43,335.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,335.23c.18.25.92,0,1.81,0s1.63.17,1.81-.09-.05-.36-.37-.59a2.53,2.53,0,0,0-1.48-.4,2.49,2.49,0,0,0-1.44.49C364.57,334.87,364.46,335.12,364.55,335.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.71,369.84c-1.43-2.46-4.64-4.1-4.62-6.95,0-1.74,1.32-3.26,1.4-5,.16-3.48-4.31-5.31-5.51-8.58-1.09-3,.79-6.31.12-9.41-.81-3.78-4.23-5.28-7.05-7.83a13.17,13.17,0,0,1-2.88-3.93c-.1-.18-.19-.36-.3-.53a12.22,12.22,0,0,0-9-5.82,19.1,19.1,0,0,0-10.46-.51,9.49,9.49,0,0,0-4.89,2.75,5.77,5.77,0,0,0-1.35,5.29,4.15,4.15,0,0,0,4.29,3c1.43-.19,2.8-1.25,4.18-.83s2,2,3.36,2.24,2.5-.94,3.84-1.06,2.76,1.09,3.42,2.42a13,13,0,0,1,.64,1.64c1.1,5.48,3.2,8,1.74,11.2-.78,1.71-2.11,3.23-2.32,5.09-.47,4.28,5.09,7.4,4.78,11.69-.13,1.83-1.32,3.38-2,5.09a8.94,8.94,0,0,0,3.05,10.08,6,6,0,0,0,5.46,1,4.11,4.11,0,0,0,.6-.28,8,8,0,0,0,3.62,1.94c3.29.7,6.73-1.16,8.74-3.86C407.5,376.16,408.3,372.56,406.71,369.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.31,380.65a10.75,10.75,0,0,0,2.72-.91,8.69,8.69,0,0,0,2.6-2.08,7.89,7.89,0,0,0,1.86-3.93,8.33,8.33,0,0,0-.92-5.16,8.51,8.51,0,0,0-4.53-3.91,7.88,7.88,0,0,1-2.93-1.85,4.28,4.28,0,0,1-.87-3.52,10.73,10.73,0,0,1,1.3-3.5,19.85,19.85,0,0,0,1.6-3.36,4.85,4.85,0,0,0-.09-3.5,9.81,9.81,0,0,0-2.08-2.88c-.82-.87-1.68-1.68-2.43-2.6a11.76,11.76,0,0,1-1.76-2.95,28.64,28.64,0,0,1-1.63-6.09,41.43,41.43,0,0,0-1.19-5.3,10.83,10.83,0,0,0-4.44-6.22,8.35,8.35,0,0,0-2.67-1H378a3.08,3.08,0,0,1,.56.08,6.26,6.26,0,0,1,2,.76,9.06,9.06,0,0,1,2.58,2.25,13,13,0,0,1,2.1,4,41.58,41.58,0,0,1,1.26,5.34,29.3,29.3,0,0,0,1.65,6,11.49,11.49,0,0,0,1.71,2.83c.72.87,1.58,1.68,2.41,2.55a10.39,10.39,0,0,1,2.18,3,5.41,5.41,0,0,1,.12,3.86c-.83,2.5-2.58,4.43-2.89,6.77a3.82,3.82,0,0,0,.74,3.13,7.55,7.55,0,0,0,2.75,1.74,9.83,9.83,0,0,1,2.8,1.69,8.75,8.75,0,0,1,2.81,7.87,8.18,8.18,0,0,1-2,4.07,8.7,8.7,0,0,1-2.73,2.06,7.7,7.7,0,0,1-2.06.66c-.25.05-.44.05-.56.07S393.31,380.66,393.31,380.65Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105,447.13l1.45-2.22,12.47,7.89L116,457.73l-.82-.41c-3.62-1.85-18.3-9.65-20.24-11.73C92.74,443.27,105,447.13,105,447.13Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.41,454.94a5.21,5.21,0,0,1,3.16-1.9,4.34,4.34,0,0,1,3.62,1l-2.13,3.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.89,445.43s-4.43-1.11-4.32-.21,14.65,9.34,21.39,12.51l.15-.3-17-9.7S99.61,445.89,98.89,445.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,457.54l-.23-.11-.65-.32-2.37-1.25c-2-1.06-4.74-2.57-7.72-4.3s-5.66-3.36-7.58-4.56l-2.26-1.44-.6-.4-.21-.15a.86.86,0,0,1,.23.12l.62.37,2.29,1.39c1.93,1.18,4.61,2.78,7.6,4.52s5.71,3.25,7.69,4.34l2.34,1.3.64.35C116.24,457.49,116.32,457.53,116.31,457.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,447.93a5.84,5.84,0,0,0,.21-1.36,6,6,0,0,0-.27-1.34,2,2,0,0,1,.45,1.34A2,2,0,0,1,99,447.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82,448.2a1.45,1.45,0,0,1-.12-.72,1.49,1.49,0,0,1,.06-.73,1.59,1.59,0,0,1,.12.72A1.64,1.64,0,0,1,103.82,448.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.16,448.25s-.17-.23-.27-.56a1.18,1.18,0,0,1-.11-.61s.17.23.28.56S105.21,448.24,105.16,448.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51,447.43a1.78,1.78,0,0,1-.71-.3c-.37-.21-.65-.41-.63-.46a1.92,1.92,0,0,1,.72.3C106.26,447.18,106.54,447.39,106.51,447.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.23,446.71a1.43,1.43,0,0,1-.87-.21c-.45-.22-.73-.51-.7-.55a4.76,4.76,0,0,1,.78.39A5.11,5.11,0,0,1,107.23,446.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,446.84a2.75,2.75,0,0,1-.82-.48,6.59,6.59,0,0,1-.76-.7,3.3,3.3,0,0,1-.37-.49.54.54,0,0,1-.06-.38.36.36,0,0,1,.31-.25,1.74,1.74,0,0,1,1.61,1.52,1.62,1.62,0,0,1-.06.7c0,.16-.09.23-.1.23a2.84,2.84,0,0,0,0-.91,1.67,1.67,0,0,0-.43-.86,1.43,1.43,0,0,0-1-.5c-.18,0-.22.2-.13.37a3.1,3.1,0,0,0,.35.46,5.92,5.92,0,0,0,.71.71C103.73,446.63,104,446.81,104,446.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,446.76a1,1,0,0,1,.24-.63,1.5,1.5,0,0,1,.57-.46,1,1,0,0,1,.92,0,.38.38,0,0,1,0,.53,1.11,1.11,0,0,1-.35.28,2.73,2.73,0,0,1-.68.27,1.26,1.26,0,0,1-.66.06s.25,0,.62-.18a3.14,3.14,0,0,0,.63-.29c.22-.11.47-.37.29-.53a.81.81,0,0,0-.74,0,1.54,1.54,0,0,0-.54.39A3.43,3.43,0,0,0,103.79,446.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,453.9s-.35-.24-1-.51a4.59,4.59,0,0,0-4.88.72c-.51.43-.75.79-.77.77s0-.1.15-.26a3.52,3.52,0,0,1,.53-.6,4.51,4.51,0,0,1,5-.75,4.27,4.27,0,0,1,.69.43A1.19,1.19,0,0,1,118.08,453.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.52,452.77a8.47,8.47,0,0,1-2-.9,8.34,8.34,0,0,1-1.78-1.23s.83.5,1.87,1.08S110.54,452.72,110.52,452.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,454.21c0,.05-.17.14-.36.28s-.34.29-.39.26,0-.24.28-.4S113,454.17,113,454.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,453.59c0,.05-.14.13-.35.19s-.39.06-.41,0,.15-.14.36-.19S114.63,453.54,114.64,453.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,453.84s-.2-.06-.43-.11-.42,0-.43-.07.19-.16.47-.1S116.33,453.81,116.3,453.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,454.14c0,.05-.12.07-.24.05s-.23-.07-.23-.12.12-.07.25-.05S117.41,454.09,117.4,454.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,437.74l-49.81-47a16.38,16.38,0,0,0-11.71-4.93h0a16.38,16.38,0,0,0-14.21,8.25l-29.86,49.49L122,454.75,148.88,416l24.59,22.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,440.09c.21.63,1.69,16.68-19.85,16.68H146.65a13.18,13.18,0,0,1-13.18-13.19h0a13.19,13.19,0,0,1,13.18-13.19h53.58a13.14,13.14,0,0,1,5.55,1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,430.39c0,.13,11.88.24,26.54.24s26.54-.11,26.54-.24-11.88-.23-26.54-.23S141.57,430.27,141.57,430.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.45,405c-.14,0-.14,2.49-.6,5.51s-1.15,5.41-1,5.45a17.58,17.58,0,0,0,1.47-5.38A17.24,17.24,0,0,0,150.45,405Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,404.66a34.68,34.68,0,0,0,1,11.24c.13,0-.22-2.52-.48-5.62S148.14,404.66,148,404.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.62,334a1.67,1.67,0,0,0,2.7,1.5c1-.76.83-2.29.38-3.45s-1.11-2.37-.82-3.58a8.44,8.44,0,0,1,1.47-2.42,5.37,5.37,0,0,0,.59-4.76,4.51,4.51,0,0,0-3.72-2.89c-1.69-.13-3.56.74-5-.18-1-.67-1.35-2-2.21-2.91-1.34-1.35-3.58-1.17-5.39-.56s-3.57,1.58-5.47,1.48c-1.59-.08-3-.9-4.59-1.27a8.34,8.34,0,0,0-8.46,13.31c.77,1,2.52,3.86,6,3.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.64,320.91l.47,2.5,7.23,37.3c.84,4.33-2.22,8.5-6.86,9.37h0c-4.69.87-9.24-2-10.16-6.32-1-4.58-2.06-9.38-2.06-9.38s-6.11.25-8.93-7.2c-1.4-3.7-2.51-10-3.25-15.21a8.3,8.3,0,0,1,7.39-9.45Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05,337a1,1,0,0,0,1.16.8,1,1,0,0,0,.83-1.1,1,1,0,0,0-1.15-.8A1,1,0,0,0,170.05,337Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,335c.14.1.78-.61,1.84-.83s1.95.16,2,0-.13-.27-.52-.45a2.72,2.72,0,0,0-1.66-.16,2.62,2.62,0,0,0-1.44.82C169.11,334.65,169,334.9,169.12,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.54,334.84a1,1,0,0,0,1.16.8,1,1,0,0,0,.83-1.11,1,1,0,0,0-1.16-.8A1,1,0,0,0,180.54,334.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.6,333c.15.1.78-.61,1.84-.83s2,.16,2.05,0-.13-.27-.52-.45a2.76,2.76,0,0,0-1.67-.16,2.65,2.65,0,0,0-1.44.82C179.59,332.68,179.53,332.93,179.6,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.38,341.66a7.34,7.34,0,0,0-1.79,0c-.28,0-.55,0-.63-.14a1.52,1.52,0,0,1,0-.85c.12-.7.25-1.45.38-2.23a36.43,36.43,0,0,0,.68-5.78,36.87,36.87,0,0,0-1.15,5.71c-.11.79-.23,1.53-.33,2.24a1.57,1.57,0,0,0,.08,1.1.69.69,0,0,0,.53.3,1.74,1.74,0,0,0,.47,0A7.38,7.38,0,0,0,177.38,341.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,354.38a20,20,0,0,0,9.74-4.89s-1.41,5.81-9.26,6.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.66,341.74c-.18,0,.06,1.18-.76,2.21s-2.07,1.15-2,1.31.32.17.84.07a2.87,2.87,0,0,0,1.72-1,2.53,2.53,0,0,0,.56-1.83C180.92,342,180.74,341.72,180.66,341.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.46,328.87c.17.27,1.2-.09,2.48-.2s2.35,0,2.46-.27c0-.14-.18-.37-.64-.57a4.36,4.36,0,0,0-3.77.36C178.57,328.47,178.39,328.74,178.46,328.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.87,331.79c.23.2.91-.2,1.79-.39s1.66-.18,1.78-.47c.05-.13-.12-.35-.49-.51a2.52,2.52,0,0,0-1.55-.09,2.48,2.48,0,0,0-1.33.78C168.81,331.42,168.76,331.69,168.87,331.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,328.6s4.36,1.25,9.13-2.28c3.14-2.31,7-3.85,8-3.31s1.81,4,5.39,4.47c0,0,.95,6.79,3.59,6.08s-.54-14.07-.54-14.07l-7.46,1.14-7.42-.1-6.6,2.14-5,2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.45,317.54c0-.11-.66-.21-1.35.21s-.9,1.07-.79,1.11.43-.41,1-.76S191.45,317.66,191.45,317.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,315.74a8.5,8.5,0,0,0,.13,1.75c.06.94-.2,1.68-.09,1.73a2.14,2.14,0,0,0,.5-1.75A2.72,2.72,0,0,0,188.76,315.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.49,330.83c.09-.07,4.13-2.45,5.11,2s-3.72,4.54-3.76,4.42S191.49,330.83,191.49,330.83Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.84,335.28s.09,0,.23.07a.8.8,0,0,0,.59-.12,1.94,1.94,0,0,0,.51-1.92,2.47,2.47,0,0,0-.46-1.07.92.92,0,0,0-.72-.47.39.39,0,0,0-.41.31c0,.14,0,.22,0,.23s-.11-.05-.11-.24a.48.48,0,0,1,.11-.32.63.63,0,0,1,.41-.21,1.14,1.14,0,0,1,1,.52,2.78,2.78,0,0,1,.54,1.19,2.06,2.06,0,0,1-.72,2.18.88.88,0,0,1-.74,0C193.87,335.39,193.82,335.29,193.84,335.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.27 430.02 185.27 427.06 143.2 427.92 118.97 389.22 116.75 390.82 141.57 430.39 185.27 430.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16,417.12,154,420.26v6.46a1.4,1.4,0,0,0,1.54-.62,25.71,25.71,0,0,0,1-3.87l1,2.65a2.28,2.28,0,0,0,2.68,1.39l7.8-2-3.19-9.11Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,356a11.5,11.5,0,0,1,8.45.57c3.93,1.86,7.56,6.81,9.75,12.59s7.72,15.6,12,32.47c3.74,14.72,8.62,30.21,4.57,35.72l-.09.11a8.34,8.34,0,0,1-9.52,2.85l-3.95-1.41a69.43,69.43,0,0,1-23.39-14.09L178,412.25l5.52-4.2s-4.29-27.39-2.5-37.81C182.55,361.23,189.29,357.52,193.93,356Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.85,369.18l7.69,36a12.88,12.88,0,0,1-8.19,14.8l-33.45,6.41-4.17-12.47h0l27.15-8.46-8-34.76Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.83,412a.91.91,0,0,0-.05.21l-.13.62c0,.14-.06.3-.09.46l-.2.54-.22.62-.37.67a8.87,8.87,0,0,1-2.71,2.86,15.07,15.07,0,0,1-4.9,2.14l-33.1,6.06.23.13c-1.38-3.95-2.84-8.13-4.35-12.48l-.14.28L192,405.66l.2-.07-.05-.21-1.49-5.84c-1.58-6.3-3.06-12.46-4.34-18.45-.63-3-1.23-5.94-1.64-8.85-.12-.72-.12-1.44-.18-2.16a9.2,9.2,0,0,1,.23-2.1,8.94,8.94,0,0,1,1.85-3.69,9.07,9.07,0,0,1,7.1-3.17,9.23,9.23,0,0,1,6.58,3.33,17.41,17.41,0,0,1,3.4,6.25,55.44,55.44,0,0,1,1.53,6.48c1.65,8.34,3,15.09,3.91,19.78.46,2.32.83,4.13,1.08,5.37.13.6.22,1.07.29,1.4s.12.47.12.47,0-.16-.07-.48-.14-.8-.25-1.4c-.23-1.26-.57-3.07-1-5.39-.89-4.7-2.17-11.46-3.76-19.81a53.55,53.55,0,0,0-1.52-6.53,17.69,17.69,0,0,0-3.44-6.4,9.66,9.66,0,0,0-6.86-3.48,9.46,9.46,0,0,0-7.43,3.31,9.12,9.12,0,0,0-2,3.86,10.19,10.19,0,0,0-.25,2.21c.06.73.06,1.48.18,2.21.41,2.93,1,5.88,1.64,8.89,1.28,6,2.76,12.16,4.33,18.46.51,2,1,4,1.49,5.84l.16-.27-27.14,8.48-.21.07.07.21c1.53,4.34,3,8.51,4.38,12.46l.06.16.17,0c13.69-2.56,25.08-4.65,33.07-6.22a15.37,15.37,0,0,0,5-2.22,8.94,8.94,0,0,0,2.71-2.95l.35-.68.22-.64c.07-.2.13-.38.18-.55l.08-.46.1-.64A1.67,1.67,0,0,0,210.83,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.54,410.15c.06,0,.1-.42-.07-1.08a4.93,4.93,0,0,0-1.34-2.23,5,5,0,0,0-2.29-1.25c-.66-.15-1.08-.08-1.08,0s.4.13,1,.34a6.06,6.06,0,0,1,2.06,1.27,6,6,0,0,1,1.35,2C196.4,409.76,196.47,410.16,196.54,410.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.63,368.7a206.94,206.94,0,0,1,8.06,38.43,30.8,30.8,0,0,1,.17,9,11.14,11.14,0,0,1-4.52,7.57,11.27,11.27,0,0,1-8.18,1.24c-2.77-.52-7.26-1.14-9.81-2.35l15-3.08s9.65-.6,5.51-19.08S203.63,368.7,203.63,368.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182,369.18l-2.71-8.47L197,349l2.39,8.26s-9.19,1-11.57,3.49S182,369.18,182,369.18Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.86,364a6.09,6.09,0,0,1-1-2.28,6,6,0,0,1-.49-2.43,6.1,6.1,0,0,1,1,2.28A6,6,0,0,1,182.86,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.24,361.86a6.29,6.29,0,0,1-1-2.28,6,6,0,0,1-.49-2.43,11.8,11.8,0,0,1,1.48,4.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.62,359.75a6.29,6.29,0,0,1-1-2.28,6,6,0,0,1-.49-2.44,6.1,6.1,0,0,1,1,2.28A6,6,0,0,1,189.62,359.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.73,357.85a6.1,6.1,0,0,1-1-2.28,6,6,0,0,1-.49-2.44,6.29,6.29,0,0,1,1,2.28A6,6,0,0,1,192.73,357.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,355.56a5.91,5.91,0,0,1-1-2.27,6.37,6.37,0,0,1-.5-2.44,11.61,11.61,0,0,1,1.49,4.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,421a4.79,4.79,0,0,1,.83-.27l2.42-.68,8.93-2.39,13.26-3.49,3.84-1a11.76,11.76,0,0,0,1.91-.58,5.19,5.19,0,0,0,1.61-1.14,5.29,5.29,0,0,0,1.49-3.7,7.77,7.77,0,0,0-.36-2.08c-.18-.72-.36-1.43-.54-2.16l-7.42-29.58c-.91-3.76-1.66-6.81-2.18-9l-.57-2.45a5,5,0,0,1-.17-.86,4.79,4.79,0,0,1,.27.83q.24.9.66,2.43c.57,2.16,1.37,5.2,2.35,8.94,2,7.6,4.61,18,7.56,29.55.18.72.37,1.44.55,2.15a8.45,8.45,0,0,1,.37,2.21,5.83,5.83,0,0,1-3.41,5.3,12.62,12.62,0,0,1-2,.61l-3.84,1L179.7,418l-9,2.24-2.44.58A6.75,6.75,0,0,1,167.43,421Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.11,422.93l.22-.08.65-.2,2.53-.72,9.31-2.54,13.83-3.7,4-1.07c.67-.18,1.39-.34,2-.56a5.35,5.35,0,0,0,1.77-1.06,5.28,5.28,0,0,0,1.74-3.77,6.65,6.65,0,0,0-.35-2.17l-.6-2.24L195,374.05c-1-3.91-1.84-7.09-2.43-9.34-.27-1.07-.48-1.92-.64-2.54l-.15-.67c0-.15,0-.23,0-.23a.73.73,0,0,1,.09.22c.06.17.12.39.2.65.18.62.43,1.46.73,2.52.63,2.24,1.51,5.41,2.6,9.3,2.15,7.9,5.11,18.75,8.37,30.73.21.75.41,1.5.61,2.24a7.18,7.18,0,0,1,.36,2.32,5.78,5.78,0,0,1-1.92,4.13,5.93,5.93,0,0,1-1.94,1.16c-.73.23-1.4.37-2.09.57l-4,1-13.86,3.6-9.35,2.38-2.55.62-.67.15A.67.67,0,0,1,168.11,422.93Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.7,427.47c-1.32,1.89-3.89,1.27-5.09.11a9.66,9.66,0,0,1-2.16-4.42c-1-3.65-2.1-7.47-1.32-11.19a6.21,6.21,0,0,1,1.43-3,3.25,3.25,0,0,1,3.07-1c1.3.34,2.11,1.61,2.69,2.82A26.85,26.85,0,0,1,270,422.17a9.29,9.29,0,0,1-1.26,5.3",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.7,427.47c-1.32,1.89-3.89,1.27-5.09.11a9.66,9.66,0,0,1-2.16-4.42c-1-3.65-2.1-7.47-1.32-11.19a6.21,6.21,0,0,1,1.43-3,3.25,3.25,0,0,1,3.07-1c1.3.34,2.11,1.61,2.69,2.82A26.85,26.85,0,0,1,270,422.17a9.29,9.29,0,0,1-1.26,5.3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M263.74,437.05a11.44,11.44,0,0,0-7.12-.86,5.91,5.91,0,0,0-3.52,1.57,2.53,2.53,0,0,0,0,3.51,3.32,3.32,0,0,0,2.21.56c1.89,0,4-.35,5.48.78.86.65,1.43,1.72,2.45,2a2.42,2.42,0,0,0,2.67-1.19,4.14,4.14,0,0,0,.31-3.06A4.7,4.7,0,0,0,263.74,437.05Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.34,430.19a6.89,6.89,0,0,1-1.07-6.34,12.21,12.21,0,0,1,3.75-5.44,20.33,20.33,0,0,1,6.72-4,7.15,7.15,0,0,1,3-.51,3.17,3.17,0,0,1,2.54,1.54c.71,1.34,0,3-.7,4.31a50.9,50.9,0,0,1-4.42,6.72,11.92,11.92,0,0,1-4.85,4.16c-2,.77-4.11.68-5.18-.72",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,456a5.11,5.11,0,0,1-.12-.86c-.06-.62-.13-1.41-.22-2.35s-.26-2.16-.53-3.44a26.24,26.24,0,0,0-1.25-4.06,15,15,0,0,0-2.08-3.67,7.62,7.62,0,0,0-2.62-2.18,7.2,7.2,0,0,0-2.21-.69,5.08,5.08,0,0,1-.85-.12,3.68,3.68,0,0,1,.87,0,6.72,6.72,0,0,1,2.3.6,7.75,7.75,0,0,1,2.77,2.2,14.61,14.61,0,0,1,2.15,3.75,24.53,24.53,0,0,1,1.24,4.13,29.68,29.68,0,0,1,.46,3.48c.07,1,.1,1.8.11,2.36A3.68,3.68,0,0,1,268.79,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.63,454.21a1.87,1.87,0,0,1,0-.4v-1.14c0-1,0-2.43-.05-4.2-.09-3.53-.39-8.42-1-13.79s-1.38-10.2-2.09-13.66c-.17-.87-.34-1.65-.5-2.34s-.29-1.27-.41-1.75l-.27-1.11a1.7,1.7,0,0,1-.07-.39,1.47,1.47,0,0,1,.14.37c.09.29.2.65.33,1.09s.3,1.06.47,1.75.37,1.46.55,2.33a128.29,128.29,0,0,1,2.2,13.68c.59,5.37.86,10.27.88,13.82,0,1.77,0,3.21-.06,4.2,0,.46-.05.84-.07,1.14A1.87,1.87,0,0,1,268.63,454.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61,444.76a6.8,6.8,0,0,1,0-1.19c0-.77.15-1.88.36-3.23a43.8,43.8,0,0,1,1-4.71,42.46,42.46,0,0,1,2-5.56,29.44,29.44,0,0,1,5.78-9,15.24,15.24,0,0,1,1.35-1.27c.21-.17.4-.35.58-.49l.53-.36a6.32,6.32,0,0,1,1-.64,33.22,33.22,0,0,0-3.28,2.93,31.19,31.19,0,0,0-5.64,9,45.62,45.62,0,0,0-2,5.51,47.17,47.17,0,0,0-1.12,4.66c-.25,1.34-.39,2.44-.47,3.2A10,10,0,0,1,268.61,444.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.63,441.1c-.56-2.21.9-4.42,2.54-6s3.57-3,4.43-5.13c1.39-3.42-.43-7.87,1.92-10.72,1.39-1.67,3.85-2.22,5.08-4a9.15,9.15,0,0,0,1.11-3.21,32.68,32.68,0,0,1,8.21-15.15,28.32,28.32,0,0,1-3.27,14.63c-1,1.79-2.13,3.54-2.45,5.54-.53,3.26,1.27,6.63.45,9.83-.93,3.65-5.06,6.08-5.28,9.85-.18,3.19,2.58,6,2.36,9.18a8.59,8.59,0,0,1-1.44,3.77c-2.49,4.08-6.12,6.88-11.61,6.76l-6.72.2Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M663.63,441.1c-.56-2.21.9-4.42,2.54-6s3.57-3,4.43-5.13c1.39-3.42-.43-7.87,1.92-10.72,1.39-1.67,3.85-2.22,5.08-4a9.15,9.15,0,0,0,1.11-3.21,32.68,32.68,0,0,1,8.21-15.15,28.32,28.32,0,0,1-3.27,14.63c-1,1.79-2.13,3.54-2.45,5.54-.53,3.26,1.27,6.63.45,9.83-.93,3.65-5.06,6.08-5.28,9.85-.18,3.19,2.58,6,2.36,9.18a8.59,8.59,0,0,1-1.44,3.77c-2.49,4.08-6.12,6.88-11.61,6.76l-6.72.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M657.6,456.8a5.55,5.55,0,0,1-1.85-.05,11.05,11.05,0,0,1-2.18-.57,9.24,9.24,0,0,1-2.69-1.49,3.69,3.69,0,0,1-1.1-1.48,7,7,0,0,1-.31-2,20.59,20.59,0,0,0-.14-2.18,6,6,0,0,0-.81-2.16c-.78-1.4-2.09-2.72-2.51-4.62a15.24,15.24,0,0,1,.22-5.88,12.55,12.55,0,0,0-.12-6.32c-.71-2.1-2.17-4-2.9-6.38s-.36-5-.5-7.51a9.77,9.77,0,0,0-.86-3.74c-.53-1.19-1.28-2.31-1.86-3.57-1.18-2.54-1.37-5.41-1.68-8.22-.16-1.42-.31-2.85-.46-4.3a20.89,20.89,0,0,0-.72-4.3,37.9,37.9,0,0,0-1.59-4.17,15,15,0,0,1-.77-2.17,23.19,23.19,0,0,1-.2-2.32,26.87,26.87,0,0,1,.21-4.65c.19-1.55.48-3.08.65-4.64l0-.26,0-.31.27.14a10.29,10.29,0,0,1,3.6,3.07,16.31,16.31,0,0,1,2.2,4.11,50.1,50.1,0,0,1,2,8.81,23.7,23.7,0,0,0,2.71,8.14c.73,1.2,1.61,2.3,2.39,3.47a9.43,9.43,0,0,1,1.64,3.84c.38,2.85-1.2,5.33-.88,7.85a8.84,8.84,0,0,0,1.2,3.5c.61,1.07,1.32,2.07,2,3.08a19,19,0,0,1,1.79,3.11,9.83,9.83,0,0,1,.81,3.37c.15,2.27-.19,4.42,0,6.45a14.89,14.89,0,0,0,1.62,5.53c.81,1.66,1.7,3.16,2.45,4.61a22.94,22.94,0,0,1,1,2.15,10.92,10.92,0,0,1,.58,2.13,13.3,13.3,0,0,1,0,3.83,9.56,9.56,0,0,1-1.95,4.88,4.56,4.56,0,0,1-.54.59,2.63,2.63,0,0,1-.45.37l-.38.27a9.31,9.31,0,0,0,1.31-1.28,9.83,9.83,0,0,0,1.85-4.85,13.44,13.44,0,0,0-.07-3.78,9.68,9.68,0,0,0-.58-2.08c-.28-.69-.63-1.4-1-2.12-.76-1.44-1.66-2.93-2.48-4.6a15,15,0,0,1-1.69-5.63c-.16-2.07.16-4.23,0-6.44a9.38,9.38,0,0,0-.79-3.26,19.55,19.55,0,0,0-1.76-3.05c-.68-1-1.4-2-2-3.1A9.08,9.08,0,0,1,649.1,413c-.31-2.68,1.26-5.19.87-7.83a9.14,9.14,0,0,0-1.59-3.67c-.76-1.15-1.65-2.25-2.4-3.48a24.34,24.34,0,0,1-2.78-8.28,49.42,49.42,0,0,0-2-8.74,16.06,16.06,0,0,0-2.14-4,10,10,0,0,0-3.45-3l.31-.17,0,.27c-.18,1.58-.47,3.11-.66,4.65a28.14,28.14,0,0,0-.2,4.58c0,.74.08,1.53.19,2.24a13.2,13.2,0,0,0,.75,2.1,37.49,37.49,0,0,1,1.59,4.21,20.9,20.9,0,0,1,.73,4.37c.16,1.45.31,2.88.46,4.3.3,2.83.5,5.65,1.63,8.1.56,1.22,1.31,2.35,1.86,3.58a10.38,10.38,0,0,1,.88,3.88c.13,2.59-.22,5.13.47,7.43s2.14,4.2,2.86,6.37a12.81,12.81,0,0,1,.11,6.47,15,15,0,0,0-.25,5.78c.38,1.81,1.65,3.12,2.45,4.56a6.19,6.19,0,0,1,.82,2.25,21.38,21.38,0,0,1,.13,2.2,7.2,7.2,0,0,0,.27,2,3.64,3.64,0,0,0,1,1.42,8.93,8.93,0,0,0,2.62,1.49,11.19,11.19,0,0,0,2.15.6,8.81,8.81,0,0,0,1.37.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.82,377.51l.06.21c0,.16.09.36.14.6.13.53.29,1.33.53,2.33s.87,2.13,1.38,3.52,1.07,3,1.57,4.78.94,3.78,1.41,5.92a25,25,0,0,0,2.11,6.57c.55,1.1,1.16,2.21,1.65,3.42a16,16,0,0,1,.94,3.86,79.31,79.31,0,0,0,1.4,8.14c1.32,5.51,2.57,10.76,3.71,15.54s2.23,9.07,3.12,12.69,1.56,6.5,2.06,8.55l.54,2.34c0,.24.09.44.13.61a1,1,0,0,1,0,.21.8.8,0,0,1-.07-.2l-.18-.6c-.15-.56-.35-1.34-.61-2.31l-2.2-8.53c-.91-3.61-2-7.9-3.2-12.66s-2.42-10-3.75-15.55a77.64,77.64,0,0,1-1.4-8.17,15.4,15.4,0,0,0-.91-3.77c-.47-1.18-1.07-2.28-1.62-3.39a25.37,25.37,0,0,1-2.1-6.68c-.45-2.14-.87-4.12-1.36-5.91s-1-3.39-1.5-4.77-1.07-2.53-1.31-3.56-.35-1.82-.45-2.36c0-.25-.08-.45-.1-.61A.72.72,0,0,1,636.82,377.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.41,456.81c-4.37-2.63-5.59-10.56-3.73-15.31s5.09-9.1,5.61-14.18c.4-3.9-.85-7.92.08-11.73,1.26-5.15,6.31-9.11,6.28-14.41,0-3-1.69-5.77-1.54-8.74.19-3.64,3-6.52,4.75-9.72,2.68-4.89,2.88-10.7,3.82-16.2s3.07-11.38,8-14.06c.69,4.68,1.9,7.89,1.48,14.22-.15,2.27-2.82,6.61-3.21,11.59-.23,3-.39,6-.59,8.94a28.68,28.68,0,0,1-1.46,8.56c-.81,2.08-2.1,4-2.7,6.11-1.14,4,.3,8.41-.62,12.5-.78,3.46-3.2,6.43-3.71,9.95-.72,4.93,2.45,10.09.79,14.79-.83,2.33-2.76,4.2-3.32,6.61-.44,1.87,0,3.86-.38,5.74-.63,3-6.43,5.35-9.52,5.14",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.41,357.09a1.1,1.1,0,0,1,0,.27c0,.19-.06.45-.1.76-.11.68-.23,1.67-.46,2.95s-.93,2.74-1.47,4.48-1.14,3.75-1.64,6-1,4.74-1.4,7.42a31.47,31.47,0,0,1-2.3,8.39c-.63,1.4-1.32,2.8-1.85,4.29a19.35,19.35,0,0,0-.95,4.74,96.39,96.39,0,0,1-1.35,10.21c-1.38,6.92-2.7,13.51-3.9,19.51s-2.4,11.36-3.36,15.89-1.75,8.15-2.3,10.7c-.27,1.24-.49,2.21-.64,2.91q-.12.47-.18.75c0,.17-.07.26-.08.25a1.68,1.68,0,0,1,0-.26c0-.19.08-.44.14-.76.14-.7.33-1.68.57-2.92.52-2.57,1.25-6.22,2.16-10.73s2-9.93,3.27-15.91,2.49-12.58,3.87-19.5a98.44,98.44,0,0,0,1.34-10.18,20,20,0,0,1,1-4.84c.54-1.52,1.25-2.93,1.87-4.32a30.92,30.92,0,0,0,2.31-8.28c.47-2.67.92-5.17,1.46-7.43s1.12-4.26,1.71-6,1.26-3.19,1.53-4.45.41-2.25.54-2.92c.06-.32.11-.57.15-.76A1,1,0,0,1,678.41,357.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376,315.48c-.14,0-.26-17.91-.26-40s.12-40,.26-40,.26,17.91.26,40S376.18,315.48,376,315.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.83,313.09s0-.18,0-.54,0-.9,0-1.62c0-1.48,0-3.68,0-6.68v-.08h.08c21.51-.11,87.47-.18,165.36-.18l163,.17h.09v.09q0,5.58,0,8.41c0,.93,0,1.63,0,2.11s0,.71,0,.71,0-.24,0-.71,0-1.18,0-2.11q0-2.84,0-8.41l.09.09-163,.17c-77.89,0-143.85-.08-165.36-.18l.08-.08c0,3,0,5.2,0,6.68,0,.72,0,1.25,0,1.62S210.83,313.09,210.83,313.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.2,130.21c.14,0,.26,10.2.26,22.79s-.12,22.79-.26,22.79-.26-10.2-.26-22.79S321.05,130.21,321.2,130.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.59,130.21c.14,0,.26,10.2.26,22.79s-.12,22.79-.26,22.79-.26-10.2-.26-22.79S432.45,130.21,432.59,130.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.59,123.45s0,.3,0,.9,0,1.49,0,2.65c0,2.35,0,5.81.05,10.29,0,9,0,22.07.07,38.5V176h-.17l-161,.09L211.41,176h-.17v-.16c0-14.89.06-26.68.08-34.76,0-4,0-7.13,0-9.23,0-1,0-1.84,0-2.38s0-.8,0-.8,0,.27,0,.8,0,1.34,0,2.38c0,2.1,0,5.2,0,9.23,0,8.08,0,19.87.08,34.76l-.16-.16,166.18-.1,161,.09-.17.17c0-16.44.06-29.52.08-38.5,0-4.48,0-7.94,0-10.29,0-1.16,0-2,0-2.65S538.59,123.45,538.59,123.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.58,213.49c-.15,0-.26-8.44-.26-18.85s.11-18.85.26-18.85.26,8.44.26,18.85S378.72,213.49,378.58,213.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.92,
    y: 210.27,
    width: 101.66,
    height: 83.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.08,
    y: 232.58,
    width: 111.13,
    height: 27.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.02,
    y: 238.26,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.02,
    y: 244.05,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.02,
    y: 250.04,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55,240.29a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,346.55,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.09,240.29a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,352.09,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.63,240.29a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,357.63,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.17,240.29a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,363.17,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.09,240.29a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,406.09,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,240.29a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,411.74,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.71,240.29a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,368.71,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.91,240.29a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,395.91,240.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.25,240.29A1.26,1.26,0,1,1,373,239,1.26,1.26,0,0,1,374.25,240.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,240.29a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,379.78,240.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,240.29a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,391,240.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.34,240.29a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,416.34,240.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,240.29a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,385.32,240.29Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,240.29a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,401.18,240.29Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.82,246.34a1.26,1.26,0,1,1,1.26,1.26A1.26,1.26,0,0,1,413.82,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.54,
    cy: 246.34,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.75,246.34A1.26,1.26,0,1,1,404,247.6,1.25,1.25,0,0,1,402.75,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.46,
    cy: 246.34,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.54,
    cy: 246.34,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.64,246.34a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,348.64,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.67,246.34a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,391.67,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,246.34a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,364.47,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.13,246.34a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,386.13,246.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,246.34a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,380.59,246.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35,246.34a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,369.35,246.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.29,
    cy: 246.34,
    r: 1.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.05,246.34a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,375.05,246.34Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.45,
    cy: 246.34,
    r: 1.26,
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.29,
    cy: 251.73,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.09,251.73a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,352.09,251.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.37,
    cy: 251.73,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.17,251.73a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,363.17,251.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.09,251.73a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,406.09,251.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.48,
    cy: 251.73,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.45,
    cy: 251.73,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.65,
    cy: 251.73,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.25,251.73a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,374.25,251.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,251.73a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,379.78,251.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.77,
    cy: 251.73,
    r: 1.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.34,251.73a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,416.34,251.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.07,
    cy: 251.73,
    r: 1.26,
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,251.73a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,401.18,251.73Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.08,
    y: 266.61,
    width: 111.13,
    height: 27.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.02,
    cy: 274.04,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.81,274a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,351.81,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.1,
    cy: 274.04,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89,274a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,362.89,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82,274a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,405.82,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.21,
    cy: 274.04,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.18,
    cy: 274.04,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.38,
    cy: 274.04,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,274a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,374,274Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.25,
    cy: 274.04,
    r: 1.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.49,
    cy: 274.04,
    r: 1.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.06,274a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,416.06,274Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.05,274a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,385.05,274Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.91,274a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,400.91,274Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.55,280.09a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,413.55,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,280.09a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,408,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.47,280.09a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,402.47,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.93,280.09a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,396.93,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,280.09a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,354,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.36,280.09a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,348.36,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.39,280.09a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,391.39,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.19,280.09a1.26,1.26,0,1,1,1.26,1.26A1.25,1.25,0,0,1,364.19,280.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85,280.09a1.26,1.26,0,1,1,1.26,1.26A1.26,1.26,0,0,1,385.85,280.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,280.09a1.26,1.26,0,1,1,1.26,1.26A1.26,1.26,0,0,1,380.31,280.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.08,280.09a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,369.08,280.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.76,280.09a1.26,1.26,0,1,1,1.26,1.26A1.26,1.26,0,0,1,343.76,280.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.78,280.09a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,374.78,280.09Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.92,280.09a1.26,1.26,0,1,1,1.25,1.26A1.25,1.25,0,0,1,358.92,280.09Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,346.27,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.81,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,351.81,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,357.35,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,362.89,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82,285.48a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,405.82,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.46,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,411.46,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.43,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,368.43,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.63,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,395.63,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,285.48a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,374,285.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.51,285.48a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,379.51,285.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.75,285.48a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,390.75,285.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.06,285.48a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,416.06,285.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.05,285.48a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,385.05,285.48Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.91,285.48a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,400.91,285.48Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.02,
    y: 272.28,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.02,
    y: 278.08,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.02,
    y: 284.07,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.92 260.11 422.21 260.15 422.21 232.58 438.92 232.54 438.92 260.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.92 226.58 422.21 226.63 422.21 199.06 438.92 199.01 438.92 226.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.92 293.92 422.21 293.96 422.21 266.39 438.92 266.35 438.92 293.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.89,
    y: 198.8,
    width: 111.13,
    height: 27.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.82,
    y: 204.48,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.82,
    y: 210.27,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.82,
    y: 216.26,
    width: 21.88,
    height: 3.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35,206.51a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,347.35,206.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.64,
    cy: 206.51,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.43,206.51a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,358.43,206.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.72,
    cy: 206.51,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9,206.51a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,406.9,206.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.29,
    cy: 206.51,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.51,206.51a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,369.51,206.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.46,
    cy: 206.51,
    r: 1.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.05,206.51a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,375.05,206.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,206.51a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,380.59,206.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.83,206.51a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,391.83,206.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.14,206.51a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,417.14,206.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.13,206.51a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,386.13,206.51Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.73,
    cy: 206.51,
    r: 1.26,
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.63,212.57a1.26,1.26,0,1,1,1.25,1.25A1.25,1.25,0,0,1,414.63,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.09,212.57a1.26,1.26,0,1,1,1.26,1.25A1.25,1.25,0,0,1,409.09,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.55,212.57a1.26,1.26,0,1,1,1.26,1.25A1.25,1.25,0,0,1,403.55,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,212.57a1.26,1.26,0,1,1,1.26,1.25A1.25,1.25,0,0,1,398,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,212.57a1.26,1.26,0,1,1,1.25,1.25A1.25,1.25,0,0,1,355.09,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,212.57a1.26,1.26,0,1,1,1.25,1.25A1.25,1.25,0,0,1,349.44,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.47,212.57a1.26,1.26,0,1,1,1.26,1.25A1.25,1.25,0,0,1,392.47,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.27,212.57a1.26,1.26,0,1,1,1.26,1.25A1.25,1.25,0,0,1,365.27,212.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.93,212.57a1.26,1.26,0,1,1,1.26,1.25A1.26,1.26,0,0,1,386.93,212.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.39,212.57a1.26,1.26,0,1,1,1.26,1.25A1.26,1.26,0,0,1,381.39,212.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.16,212.57a1.26,1.26,0,1,1,1.25,1.25A1.25,1.25,0,0,1,370.16,212.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.84,212.57a1.26,1.26,0,1,1,1.26,1.25A1.26,1.26,0,0,1,344.84,212.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.86,212.57a1.26,1.26,0,1,1,1.25,1.25A1.25,1.25,0,0,1,375.86,212.57Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,212.57a1.26,1.26,0,1,1,1.25,1.25A1.25,1.25,0,0,1,360,212.57Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,347.35,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.89,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,352.89,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.43,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,358.43,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,364,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9,218a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,406.9,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.54,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,412.54,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.51,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,369.51,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.71,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,396.71,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.05,218a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,375.05,218Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,218a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,380.59,218Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.83,218a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,391.83,218Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.14,218a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,417.14,218Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.13,218a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,386.13,218Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,218a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,402,218Z",
    style: {
      fill: "#70FD8D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.16,135.68H405.83a6.17,6.17,0,0,1-6.17-6.17V61.23a6.17,6.17,0,0,1,6.17-6.17h31.29l24.21,25v49.49A6.17,6.17,0,0,1,455.16,135.68Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400.9,111.22h59.19a1.24,1.24,0,0,1,1.24,1.24V129.2a6.48,6.48,0,0,1-6.48,6.48H406.14a6.48,6.48,0,0,1-6.48-6.48V112.46A1.24,1.24,0,0,1,400.9,111.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.12,55.06V74.28A5.74,5.74,0,0,0,442.86,80h18.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M437.37,76s-.24,4.66,5.06,6.19c.2.06.41.1.61.14,2.41.43,18.29,3.26,18.29,2.89V80H442.86S438.24,79.86,437.37,76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M417.32,121.88a5.28,5.28,0,0,1,9.15-3.26L425,119.93a3.07,3.07,0,0,0-2.41-1.12,3.07,3.07,0,1,0,0,6.14,3.06,3.06,0,0,0,2.41-1.14l1.43,1.31a5.27,5.27,0,0,1-9.15-3.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.12,125.73l.76-1.68a5.6,5.6,0,0,0,3.16,1c1.32,0,1.85-.43,1.85-1,0-1.8-5.58-.56-5.58-4.13,0-1.63,1.32-3,4.05-3a6.4,6.4,0,0,1,3.33.85l-.69,1.68a5.38,5.38,0,0,0-2.66-.75c-1.31,0-1.82.49-1.82,1.09,0,1.77,5.58.55,5.58,4.07,0,1.61-1.33,3-4.07,3A6.92,6.92,0,0,1,427.12,125.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.86,125.73l.75-1.68a5.66,5.66,0,0,0,3.17,1c1.31,0,1.85-.43,1.85-1,0-1.8-5.58-.56-5.58-4.13,0-1.63,1.32-3,4-3a6.35,6.35,0,0,1,3.33.85l-.68,1.68a5.38,5.38,0,0,0-2.66-.75c-1.32,0-1.82.49-1.82,1.09,0,1.77,5.57.55,5.57,4.07,0,1.61-1.32,3-4.06,3A6.89,6.89,0,0,1,435.86,125.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.45,90.83c1,.31,1.48,1,1.48,2.47v3.53a1.45,1.45,0,0,0,1.6,1.63h.4v2.69h-1.28c-2.75,0-4.16-1.41-4.16-4v-4a.9.9,0,0,0-1-1h-.73V89.49h.73a.91.91,0,0,0,1-1v-4c0-2.54,1.41-4,4.16-4h1.28v2.69h-.4a1.45,1.45,0,0,0-1.6,1.63v3.53C421.93,89.89,421.46,90.53,420.45,90.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.2,89.49v2.69h-.72a.9.9,0,0,0-1,1v4c0,2.54-1.41,4-4.17,4h-1.27V98.46h.39a1.45,1.45,0,0,0,1.61-1.63V93.3c0-1.52.46-2.16,1.48-2.47-1-.3-1.48-.94-1.48-2.46V84.84a1.45,1.45,0,0,0-1.61-1.63h-.39V80.52h1.27c2.76,0,4.17,1.41,4.17,4v4c0,.71.37,1,1,1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.86,135.68H513.54a6.17,6.17,0,0,1-6.17-6.17V61.23a6.17,6.17,0,0,1,6.17-6.17h31.28L569,80v49.49A6.18,6.18,0,0,1,562.86,135.68Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.47,102.85s.41,0,1.16-.17a5.75,5.75,0,0,0,2.86-1.64,5.59,5.59,0,0,0,1.24-2,5.8,5.8,0,0,0,.29-1.34c0-.47,0-1,0-1.5,0-2.1,0-4.48,0-7.11,0-1.32,0-2.7,0-4.13,0-.72,0-1.45,0-2.2a9.78,9.78,0,0,0-.16-2.23,6.25,6.25,0,0,0-2.52-3.76,6.06,6.06,0,0,0-2.19-1,10.25,10.25,0,0,0-2.51-.18L526,75.62a6.08,6.08,0,0,0-4.63,3,5.8,5.8,0,0,0-.83,2.64c0,.93,0,1.91,0,2.85,0,3.79,0,7.44,0,10.93,0,.86,0,1.75,0,2.55a5.61,5.61,0,0,0,.76,2.27,5.72,5.72,0,0,0,3.61,2.67,9.69,9.69,0,0,0,2.22.16h2.2l4.14,0,12.47.08,3.39,0,.89,0,.3,0a1.16,1.16,0,0,1-.3,0l-.89,0-3.39,0-12.47.08-4.14,0h-2.2a9.73,9.73,0,0,1-2.32-.15,6.2,6.2,0,0,1-3.91-2.86A6.09,6.09,0,0,1,520,97.6c-.07-.89,0-1.72,0-2.6,0-3.49,0-7.14,0-10.93,0-1,0-1.89,0-2.89a6.23,6.23,0,0,1,.89-2.86,6.62,6.62,0,0,1,5-3.22c8.09-.06,15.71,0,22.68,0a10.53,10.53,0,0,1,2.62.2,6.74,6.74,0,0,1,5,5.12,9.68,9.68,0,0,1,.16,2.32c0,.75,0,1.48,0,2.2,0,1.43,0,2.81,0,4.13,0,2.63,0,5,0,7.11,0,.52,0,1,0,1.53a6.13,6.13,0,0,1-.32,1.39,6,6,0,0,1-1.33,2.1,5.72,5.72,0,0,1-3,1.59A4.22,4.22,0,0,1,550.47,102.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556,99.63a2.52,2.52,0,0,1-.35-.37l-.95-1.13-3.38-4.19L549,91l-1.29-1.63c-.22-.27-.45-.55-.67-.84a1.75,1.75,0,0,0-.81-.52,1.72,1.72,0,0,0-1.83.54l-1.48,1.9-3.12,4-1.39,1.79-.18.23-.21-.2L534.67,93l-.8-.77a2.81,2.81,0,0,0-.79-.63,1.89,1.89,0,0,0-1.79.1,3.88,3.88,0,0,0-.71.65l-.69.71-1.31,1.35-2.36,2.41-3.42,3.45-.94.92a1.9,1.9,0,0,1-.35.29s.08-.13.28-.36.52-.59.87-1l3.3-3.56,2.32-2.46,1.29-1.37.68-.71a4.32,4.32,0,0,1,.79-.73,2.34,2.34,0,0,1,2.24-.15,3.23,3.23,0,0,1,.93.71l.81.77,3.36,3.25-.38,0c.44-.57.92-1.17,1.39-1.79l3.13-4,1.5-1.9a2.22,2.22,0,0,1,2.35-.68,2.17,2.17,0,0,1,1,.68l.68.86,1.27,1.64,2.27,2.95,3.25,4.3.87,1.18C555.92,99.46,556,99.61,556,99.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.76,86.3s.29,0,.76-.2a3.14,3.14,0,0,0,1.65-1.18,3,3,0,1,0-4.81,0A3.16,3.16,0,0,0,536,86.1c.48.15.77.16.76.2s-.28.09-.8,0a3.22,3.22,0,0,1-1.89-1.15,3.37,3.37,0,0,1-.55-3.23,3.43,3.43,0,0,1,6.48,0,3.37,3.37,0,0,1-.54,3.23,3.22,3.22,0,0,1-1.89,1.15A1.44,1.44,0,0,1,536.76,86.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M507.37,111.22H569a0,0,0,0,1,0,0v18.1a6.36,6.36,0,0,1-6.36,6.36h-49a6.36,6.36,0,0,1-6.36-6.36v-18.1A0,0,0,0,1,507.37,111.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M544.82,55.06V74.28A5.74,5.74,0,0,0,550.56,80H569Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M545.07,76s-.24,4.66,5.07,6.19a5.82,5.82,0,0,0,.6.14c2.42.43,18.3,3.26,18.3,2.89V80H550.56S546,79.86,545.07,76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M532.68,122.57h2v3.89a6.67,6.67,0,0,1-3.88,1.22,5,5,0,1,1,0-9.92,5.11,5.11,0,0,1,4,1.66l-1.43,1.31a3.25,3.25,0,0,0-2.48-1.08,3.07,3.07,0,1,0,0,6.14,3.53,3.53,0,0,0,1.73-.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.76,117.92H539v9.6h-2.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.47,119.7v2.54h4.44V124h-4.44v3.5h-2.22v-9.6h7.25v1.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.93,135.68H296.6a6.17,6.17,0,0,1-6.17-6.17V61.23a6.17,6.17,0,0,1,6.17-6.17h31.28L352.1,80v49.49A6.17,6.17,0,0,1,345.93,135.68Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M290.43,111.22H352.1a0,0,0,0,1,0,0v17.62a6.84,6.84,0,0,1-6.84,6.84h-48a6.84,6.84,0,0,1-6.84-6.84V111.22A0,0,0,0,1,290.43,111.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M312.28,127l1.56-1.87a2.77,2.77,0,0,0,2.24,1.33c1.12,0,1.7-.67,1.7-2v-5.74h-4.24v-2.24h7v7.83c0,3-1.5,4.45-4.34,4.45A4.88,4.88,0,0,1,312.28,127Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.23,127.69l.9-1.94a6.25,6.25,0,0,0,3.22.9c1.24,0,1.71-.33,1.71-.84,0-1.52-5.61,0-5.61-3.68,0-1.75,1.59-3,4.3-3a7.74,7.74,0,0,1,3.57.81l-.9,1.92a5.29,5.29,0,0,0-2.67-.69c-1.21,0-1.73.38-1.73.86,0,1.59,5.61,0,5.61,3.71,0,1.72-1.61,3-4.38,3A8,8,0,0,1,322.23,127.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.49,98.38l1.94-2.27a5.81,5.81,0,0,0,4.87,2.77c2.63,0,4-1.6,4-4.74V81h-8.44v-2.9H317.6V94c0,5.2-2.54,7.77-7.3,7.77A8.14,8.14,0,0,1,303.49,98.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7,99.61,323,97.08a11.41,11.41,0,0,0,6.2,1.83c3,0,4.2-.9,4.2-2.4,0-4-11.17-.53-11.17-7.57,0-3.16,2.83-5.3,7.37-5.3a12.83,12.83,0,0,1,6.43,1.6l-1.37,2.54a9.16,9.16,0,0,0-5.1-1.4c-2.8,0-4.16,1-4.16,2.43,0,4.17,11.2.77,11.2,7.63,0,3.21-2.94,5.24-7.64,5.24A12.74,12.74,0,0,1,321.7,99.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.88,55.06V74.28A5.74,5.74,0,0,0,333.62,80H352.1Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14,76s-.25,4.66,5.06,6.19a6,6,0,0,0,.61.14c2.41.43,18.29,3.26,18.29,2.89V80H333.62S329,79.86,328.14,76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,135.68H186.37a6.17,6.17,0,0,1-6.17-6.17V61.23a6.17,6.17,0,0,1,6.17-6.17h31.28l24.22,25v49.49A6.18,6.18,0,0,1,235.69,135.68Z",
    style: {
      fill: "#70FD8D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2,111.22h61.67a0,0,0,0,1,0,0v17.56a6.9,6.9,0,0,1-6.9,6.9H187.09a6.9,6.9,0,0,1-6.9-6.9V111.22A0,0,0,0,1,180.2,111.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.65,55.06V74.28A5.74,5.74,0,0,0,223.39,80h18.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M217.9,76s-.24,4.66,5.07,6.19a5.82,5.82,0,0,0,.6.14c2.42.43,18.3,3.26,18.3,2.89V80H223.39S218.78,79.86,217.9,76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,91l-7.4,2.71,7.4,2.69V99.2l-10.58-4V92.29l10.58-4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.48,82.79h3.09l-7.34,20.95h-3.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.55,92.29v2.89L217,99.2V96.42l7.4-2.69L217,91V88.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,120.32v8.29h-1.92v-3.4h-3.77v3.4H195.4v-8.29h1.92v3.27h3.77v-3.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.69,121.88H204v-1.56h7.23v1.56H208.6v6.73h-1.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.83,128.61v-5l-2.44,4.09h-.87l-2.42-4v4.87h-1.8v-8.29h1.58l3.1,5.15,3.06-5.15h1.57l0,8.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,120.32h1.92v6.73h4.16v1.56h-6.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.88,55.06V74.28A5.74,5.74,0,0,0,333.62,80H352.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.82,55.06V74.28A5.74,5.74,0,0,0,550.56,80H569Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticassetsPana);
export default __webpack_public_path__ + "static/media/Static assets-pana.015ffb82ba913cfd09737050a6787d39.svg";
export { ForwardRef as ReactComponent };